
// Use the built-in scroll restoration feature
if ("scrollRestoration" in history) {
    history.scrollRestoration = "auto"; // 'manual'; // or 'auto' for automatic restoration
}

window._klvReady = window._klvReady || [];
window._klvReady.push(function () {

    const SORT_ORDER = {
        "size": ["XS", "S", "S/M", "M", "M/L", "L", "XL", "L/XL", "XXL", "XXXL", "8", "8/10", "10", "10/12", "12", "12/14", "14", "14/16", "16", "16/18", "18", "18/20", "20", "20/22", "22", "22/24", "24", "26", "One", "27", "28", "29", "30", "31", "32", "33", "34", "36", "37", "38", "39", "40", "42", "42/44", "44", "46", "46/48", "48", "3", "4", "5", "6", "7", "1YR/2YR", "3YR/4YR", "5YR/6YR", "7YR/8YR", "A", "A/B", "B", "B/C", "C", "C/D", "D"],
      };

    // Create the useroptions object if it does not already exist
    if (!window.klevu_uc_userOptions) window.klevu_uc_userOptions = {};

    // set the landingFilterPosition
    window.klevu_uc_userOptions.landingFilterPosition = 'left';
    window.addEventListener('DOMContentLoaded', function () {

        if (sessionStorage.getItem('klevuSortingFlag') === null) {
            localStorage.setItem('klv_sort_productList', '');
        } 
        
      }, true);

    /* set default product limits */
    var klevu_newObject = klevu.dictionary("limits");
    klevu_newObject.setStorage("local");
    klevu_newObject.mergeFromGlobal();
    klevu_newObject.addElement("productList", 64);
    klevu_newObject.addElement("productListFallback", 64);
    klevu_newObject.addElement("contentList", 64);
    klevu_newObject.mergeToGlobal();
    

    var klevu_layoutType = 'slim';
    var klevu_productsToShowInSlimLayout = 6;

    var customStyleContent = `/* ====================================================== */
/* ====================================================== */
/* THE STRUCTURED CSS SELECTORS INSTEAD OF ORIGINAL ONES  */
/* ==================== QUICK SEARCH ==================== */
/* ======================= Breeze ======================= */
/* ====================================================== */
/* ====================================================== */



:root {
  --klevu-bgcolor: #f0f2ee;
  --klevu-white-color: white;
  --klevu-button-bg: #0a4563;
  --klevu-charcoal: #000;
  --klevu-linkBlue: #1A73E8;
  --klevu-silver: #9f9f9f;
  --klevu-font-size-small: 14px;
  --klevu-font-size-base: 16px;
  --klevu-font-size-large: 20px;
  --klevu-font-line-height-base: 1.3;
  --klevu-font-line-height-large: 1.5;
  --klevu-font-weight-base: normal;
  --klevu-font-weight-bold: bold;
  --klevu-product-image-size: 100px;
  --klevu-list-item-height: 40px;
  --klevu-list-item-border-radius: 25px;
  --klevu-list-item-gap: 4px;
}

/* MAIN CONTAINER-WRAPPER*/

body .searchRequestLoading .klevuQuickSearchingArea::after {
  top: 50%;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
}

.klevuWrap {
  left: 0 !important;
  right: 0 !important;
}

.ku-hide {
  display: none!important;
}

body .kuQuickSearchResultsContainer.klevuTarget,
.klevuWrap [ku-container][data-container-role="main"] [data-container-id="ku_quick_main_content_center"] {
  overflow-x: hidden !important;
}

body .kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled>div,
.kuQuickSearchResultsContainer.klevuTarget.klevu-fluid>div {
  max-width: 100% !important;
  min-width: unset !important;
  height: auto;
  overflow-y: initial;
  width: 100%;
  left: 0 !important;
  position: absolute;
}

.kuSearchBoxWithTerm.klevuTarget.klevu-fluid>div {
  padding: 0 !important;
  left: 0 !important;
  right: 0 !important;
}

.klevuQuickSearchingArea,
.kuEmptySearchBox.klevuTarget.kuPersonalizedSearchRecsEnabled .klevuQuickSearchingArea {
  overflow-y: auto;
  padding: 0 !important;
}

.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"],
.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.kuQuickSearchAutoCompleteLayout .klevuWrap [ku-container][data-container-role="main"] {
  max-height: calc(100vh - var(--klevuQuickPopupTopPosition));
  padding: 0 10px;
}

.kuQuickSearchAutoCompleteLayout .klevuWrap [ku-container][data-container-role="main"]::-webkit-scrollbar {
  width: 4px;
}

.kuQuickSearchAutoCompleteLayout .klevuWrap [ku-container][data-container-role="main"]::-webkit-scrollbar-track {
  background-color: transparent;
}

.kuQuickSearchAutoCompleteLayout .klevuWrap [ku-container][data-container-role="main"]::-webkit-scrollbar-thumb {
  background-color: var(--klevu-silver);
  border-radius: 2px;
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .klevuPopularProductsHeading,
.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .klevuSuggestionHeading .klevuHeadingText,
.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuSuggestionHeading .klevuHeadingText {
  margin-bottom: 15px;
  margin-top: 15px;
  color: var(--klevu-charcoal);
  font-size: 12px;
  font-weight: var(--klevu-font-weight-bold);
  line-height: var(--klevu-font-line-height-base);
  letter-spacing: 0.8px;
  text-align: left;
}

.klevuTarget.kuEmptySearchBox .klevuWrap .klevuQuickSearchingArea .kuSearchPersonalizationsContainer [data-container-id="ku_quick_main_content_container"] [data-container-role="left"] {
  padding-top: 0;
  margin-bottom: 0;
  border-bottom: 1px solid var(--klevu-bgcolor);
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuPopularSearchesBlock {
  margin-bottom: 0px;
}

.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuPopularSearchesBlock .klevuSuggestionHeading,
.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .klevuResultsBlock .klevuSuggestionHeading,
.kuSearchBoxWithTerm .klevuQuickSearchingArea [data-container-role="main"] .klevuResultsBlock .klevuSuggestionHeading,
.kuEmptySearchBox .klevuWrap .klevuSuggestionHeading {
  padding: 0;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="content"] .klevuResultsBlock {
  margin-top: 0;
  margin-bottom: 25px;
  padding: 0;
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .kuQuickNoResultsMessage,
.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap.klevuCmsSuggestions,
.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap.klevuAutosuggestions {
  padding: 0;
  border-bottom: 1px solid var(--klevu-bgcolor);
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap.klevuCategorySuggestions {
  padding: 0;
  border: 0;
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap.klevuCategorySuggestions .klevuSuggestionHeading {
  border-top: 1px solid var(--klevu-bgcolor);
  padding-top: 20px;
}

.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuRecentSearchesBlock .kuRecentSearchTerms ul,
.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuPopularSearchesBlock .kuPopularSearchTerms ul,
.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 20px;
  width: 100%;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 10px 0;
}

.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuRecentSearchesBlock .kuRecentSearchTerms ul li,
.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuPopularSearchesBlock .kuPopularSearchTerms ul li,
.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap ul li {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  white-space: nowrap;
  min-height: var(--klevu-list-item-height);
  border-radius: var(--klevu-list-item-border-radius);
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin: 0 var(--klevu-list-item-gap);
  border: 1px solid var(--klevu-bgcolor);
  background-color: var(--klevu-bgcolor);
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap.klevuCategorySuggestions ul li {
  border: 1px solid #000;
  background-color: var(--klevu-white-color);
}

.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuRecentSearchesBlock .kuRecentSearchTerms ul li:hover,
.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuPopularSearchesBlock .kuPopularSearchTerms ul li:hover,
.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap ul li:hover {
  background-color: var(--klevu-charcoal);
  border: 1px solid var(--klevu-charcoal);
}

.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuRecentSearchesBlock .kuRecentSearchTerms ul li:hover a,
.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuPopularSearchesBlock .kuPopularSearchTerms ul li:hover a,
.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap ul li:hover a {
  color: var(--klevu-white-color);
}

.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuRecentSearchesBlock .kuRecentSearchTerms ul li a,
.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuPopularSearchesBlock .kuPopularSearchTerms ul li a,
.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap ul li a {
  font-size: 12px;
  line-height: 21px;
  font-weight: var(--klevu-font-weight-base);
  color: var(--klevu-charcoal);
  text-transform: inherit;
  width: 100%;
  height: 100%;
  padding: 9px 16px;
  white-space: normal;
  letter-spacing: 0.8px;
}

.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuRecentSearchesBlock .kuRecentSearchTerms ul li a b,
.kuEmptySearchBox .klevuWrap [ku-container][data-container-role="content"] .kuPopularSearchesBlock .kuPopularSearchTerms ul li a b,
.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap ul li a b {
  font-weight: var(--klevu-font-weight-bold);
}

.kuEmptySearchBox.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider:first-child {
  /* border-bottom: 1px solid var(--klevu-bgcolor); */
  margin-bottom: 25px;
}

.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel {
  height: auto;
}

.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .kuSlide {
  position: unset;
  width: auto !important;
}

.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel-content {
  overflow: visible;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 24px;
  margin-bottom: 25px;
}

.kuPersonalizedSearchRecsEnabled .kuSlide .klevuQuickProductInnerBlock,
.klevuResultsBlock .klevuQuickSearchResults ul li a.klevuQuickProductInnerBlock {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0;
}

.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .klevuProductItemTop {
  padding: 0;
  overflow: hidden;
  margin-right: 20px;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  width: var(--klevu-product-image-size) !important;
}

.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .klevuProductItemTop .klevuQuickImgWrap {
  height: var(--klevu-product-image-size) !important;
  border: 0;
}

.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .klevuProductItemTop .klevuQuickImgWrap img {
  width: auto;
  height: auto;
}

.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .klevuProduct .klevuProductItemBottom {
  padding: 0;
}

.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .klevuProduct .klevu-brand {
  font-size: 12px;
  margin-bottom: 4px;
  color: var(--klevu-charcoal);
}

.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .klevuProductItemBottom .klevuQuickProductDescBlock .klevuQuickProductName {
  color: var(--klevu-charcoal);
  word-wrap: break-word;
  font-size: 12px;
  letter-spacing: 0.8px;
  line-height: var(--klevu-font-line-height-base);
  font-weight: var(--klevu-font-weight-bold);
  display: block !important;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom .klevuQuickProductPrice {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 5px;
}

.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .klevuProductItemBottom .klevuQuickProductDescBlock .klevuQuickProductPrice,
.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .klevuProductItemBottom .klevuQuickProductDescBlock .klevuQuickProductPrice span:not(.klevuQuickPriceGreyText),
.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom .klevuQuickProductPrice .klevuQuickSalePrice,
.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickSalePrice {
  color: var(--klevu-charcoal);
  word-wrap: break-word;
  font-size: 12px;
  letter-spacing: 0.8px;
  font-weight: 400;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  margin-bottom: 0;
  gap: 5px;
  font-family: ITC Avant Garde Gothic Std Demi, sans-serif;
}

.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li:hover {
  background-color: transparent;
}

.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .klevuProductItemBottom .klevuQuickProductDescBlock .klevuQuickProductPrice .klevuQuickOrigPrice,
.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom .klevuQuickProductPrice .klevuQuickOrigPrice {
  text-decoration: line-through;
  margin-right: 0px;
  font-size: 12px;
  letter-spacing: 0.8px;
  color: #c5c5c5 !important;
}

.klevuWrap .klevuQuickSalePrice.klevuQuickSpecialPrice {
  color: #ce0e2d !important;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom .klevuQuickProductPrice .klevuQuickSalePrice.kuStartPrice,
.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .klevuProductItemBottom .klevuQuickProductDescBlock .klevuQuickProductPrice .kuStartPrice {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 5px;
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea [data-container-role="header"] .klevuSuggestionsBlock .klevuAutoSuggestionsWrap .klevuSuggestionHeading {
  padding: 0;
  margin-top: 0;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults ul {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 15px;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults ul:before {
  content: unset;
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li a.klevuQuickPopularProductInnerBlock,
.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults ul li .klevuQuickProductInnerBlock {
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  width: 100%;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  max-width: 400px;
  margin-bottom: 20px;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults ul li,
.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li {
  border: 0;
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li a.klevuQuickPopularProductInnerBlock {
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 20px;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults ul li:hover {
  background-color: transparent;
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea .kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular .klevuPopularProductItemTop,
.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults .klevuProductItemTop,
.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-result .kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular .klevuPopularProductItemTop {
  width: unset;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  margin-right: 25px;
  padding: 0;
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea .kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular .klevuPopularProductItemTop {
  padding: 0;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom {
  width: unset;
  padding: 0;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults .klevuQuickImgWrap {
  float: none;
  overflow: hidden;
  width: var(--klevu-product-image-size) !important;
  height: var(--klevu-product-image-size) !important;
  text-align: center;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults .klevuQuickProductDescBlock {
  margin-left: 0;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults .klevuQuickProductName,
.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickProductName {
  color: var(--klevu-charcoal);
  word-wrap: break-word;
  font-size: 12px;
  letter-spacing: 0.8px;
  line-height: var(--klevu-font-line-height-base);
  font-weight: var(--klevu-font-weight-bold);
  display: block !important;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults .klevu-brand {
  color: #000;
  font-size: 12px;
  letter-spacing: 0.8px;
  line-height: var(--klevu-font-line-height-base);
  font-weight: var(--klevu-font-weight-base);
  display: block !important;
  margin-bottom: 4px;
  margin-top: 4px;
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuDividerLine,
.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .kuNoResultsPopularSearchesBlock,
.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .nav-left,
.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel .nav-right,
.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults .klevuProductItemBottom .klevu-desc-l2,
.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular .klevuPopularProductItemBottom .klevu-desc-l2 {
  display: none !important;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuProductsViewAll {
  top: 25px;
  right: 0;
}

.kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuProductsViewAll a {
  font-weight: var(--klevu-font-weight-base);
  font-size: 12px;
  letter-spacing: 0.8px;
  line-height: var(--klevu-font-line-height-base);
  text-transform: none;
  text-decoration: underline;
  color: #000;
  border: 0;
  text-transform: uppercase
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .kuQuickNoResultsMessage {
  padding: 0;
  text-transform: unset;
  margin-bottom: 25px;
  padding-bottom: 35px;
  color: var(--klevu-charcoal);
  font-size: var(--klevu-font-size-large);
  font-weight: var(--klevu-font-weight-bold);
  line-height: var(--klevu-font-line-height-large);
  letter-spacing: 0;
  text-align: center;
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .klevuPopularProductsHeading {
  padding: 0;
  text-align: center;
}

.kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular .klevuQuickImgWrap {
  width: var(--klevu-product-image-size) !important;
  height: var(--klevu-product-image-size) !important;
}

.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickPopularProductDescBlock .klevuQuickProductPrice {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 5px;
}

.kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul li .klevuQuickOrigPrice {
  margin-left: 0;
  margin-bottom: 5px;
  font-size: var(--klevu-font-size-base);
  line-height: var(--klevu-font-line-height-base);
}

body.klevu-category-page .plp_mini_layout--true {
  min-height: 205px;
}

@media screen and (max-width: 768px) {

  .klevuTarget.kuEmptySearchBox .klevuWrap .klevuQuickSearchingArea .kuSearchPersonalizationsContainer [data-container-id="ku_quick_main_content_container"] [data-container-role="left"],
  .kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuQuickSearchResults ul,
  .kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .klevuNoResultsProductsBlock .klevuQuickSearchNoResultsPopular ul,
  .kuPersonalizedSearchRecsEnabled .kuRecommendationSlider .kuCarousel-content {
    grid-template-columns: 1fr;
  }

  .kuEmptySearchBox.kuPersonalizedSearchRecsEnabled .kuRecommendationSlider:first-child {
    border-bottom: 0;
  }

  .kuEmptySearchBox.kuPersonalizedSearchRecsEnabled [data-block-id="ku_quick_left_banner"] {
    margin-bottom: 25px;
    border-bottom: 1px solid var(--klevu-bgcolor);
    padding-bottom: 24px;
  }

  .kuSearchBoxWithTerm .klevuWrap .klevuQuickSearchingArea.klevu-no-results .kuQuickSearchNoRecordFound .klevuPopularProductsHeading {
    text-align: left;
  }

}

/* ====================================================== */
/* ====================================================== */
/* THE STRUCTURED CSS SELECTORS INSTEAD OF ORIGINAL ONES  */
/* ================== LANDING & CATNAV ================== */
/* ======================== Haven ======================= */
/* ====================================================== */
/* ====================================================== */

:root {
  --klevu-button-radius: 3px;
  --klevu-product-minsize: 250px;
  --klevu-product-minsize-mobile: 200px;
  --klevu-image-fit: contain;
  /* cover */
  --klevu-image-position: center;
  /* top */
  --klevu-filter-width: 25%;
  --klevu-color-white: #fff;
  --klevu-color-black: #000;
  --klevu-color-light: #d9d9d9;
  --klevu-color-silver: #666;
  --klevu-color-green: #97C73E;
  --klevu-font-size-tiny: 12px;
  --klevu-font-size-small: 14px;
  --klevu-font-size-base: 16px;
  --klevu-font-size-large: 26px;
  --klevu-font-line-height-base: 1.3;
  --klevu-font-line-height-large: 1.5;
  --klevu-letter-spacing-tiny: 0.8px;
  --klevu-letter-spacing-small: 2px;
  --klevu-font-weight-base: normal;
  --klevu-font-weight-bold: bold;
}

.klevuLanding {
  min-height: 5000px;
}



.kuSearchResultsPageContainer.klevuLanding {
  min-height: unset;
}

.kuSearchResultsPageContainer {
  margin: auto;
  padding: 0;
  max-width: 92%;
}

/* MAIN CONTAINER-WRAPPER*/
.kuSearchResultsPageContainer [data-container-role=main] {
  margin: 0 auto;
  max-width: none;
  width: auto;
}

.kuSearchResultsPageContainer [data-container-role=main] .kuContainer {
  padding: 0;
  max-width: 100%;
}

/* FILTERS */
.kuSearchResultsPageContainer [data-container-role=left] {
  display: block;
  width: var(--klevu-filter-width);
  min-width: 200px;
  max-width: none;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters {
  padding: 0;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilters__header {
  margin: 40px 0 50px;
}

/* .kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilters__header .kuFiltersTitleHeading {} */

.kuSearchResultsPageContainer .kuFilters .kuFilters__header .kuFiltersTitleCounter {
  font-size: small;
}

.kuSearchResultsPageContainer .productList .kuFilters .kuFilters__header .kuFiltersTitleCounter .kuFiltersTitleCounter__count {
  font-size: 12px;
}

.kuSearchResultsPageContainer .productList .kuFilters .kuFilters__header .kuFiltersTitleCounter .kuFiltersTitleCounter__count:nth-child(2),
.kuSearchResultsPageContainer .contentList .kuFilters .kuFilters__header .kuFiltersTitleCounter .kuFiltersTitleCounter__count:nth-child(1) {
  display: none !important;
  visibility: hidden !important;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterHead {
  color: #000;
  font-size: 12px;
  letter-spacing: 0.8px;
}

.kuSearchResultsPageContainer [ku-container] .kuResultsHeadingTitleContainer {
  border: 0;
}

.kuSearchResultsPageContainer [ku-container] .kuFilterTagsContainer .kuFilterTag {
  min-width: 48px;
  border-radius: var(--klevu-button-radius);
  border: 1px solid var(--klevu-color-silver);
  padding: 5px 15px;
  margin-right: 8px;
}

.kuSearchResultsPageContainer [ku-container] .kuFilterTagsContainer .kuFilterTagKey {
  padding: 0;
  margin: 0;
  color: var(--klevu-color-silver);
  position: relative;
  padding-right: 5px;
  text-transform: capitalize;
  line-height: var(--klevu-font-line-height-large);
}

.kuSearchResultsPageContainer [ku-container] .kuFilterTagsContainer .kuFilterTagKey::after {
  content: ':';
  position: absolute;
  right: 0;
}

.kuSearchResultsPageContainer [ku-container] .kuFilterTagsContainer .kuFilterTagValue {
  padding: 0;
  margin: 0;
  background-color: transparent;
  color: var(--klevu-color-silver);
  line-height: var(--klevu-font-line-height-large);
}

.kuSearchResultsPageContainer [ku-container] .kuFilterTagsContainer .kuFilterTagClearAll {
  padding: 0;
  margin: 0;
  border: 0;
  color: var(--klevu-color-silver);
  text-decoration: underline;
  text-transform: capitalize;
  border-radius: 0;
}

.kuFilterBox .kuFilterHead.kuCollapse::after,
.kuFilterBox .kuFilterHead.kuExpand::after {
  top: calc(50% - 6px);
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames:not(.sliderFilterNames) {
  overflow: auto;
  max-height: 200px;
}

/* Custom scrollbar styles for WebKit-based browsers */
.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames:not(.sliderFilterNames)::-webkit-scrollbar {
  width: 5px;
  border-radius: 2px;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames:not(.sliderFilterNames)::-webkit-scrollbar-track {
  background-color: var(--klevu-color-light);
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames:not(.sliderFilterNames)::-webkit-scrollbar-thumb {
  background-color: var(--klevu-color-silver);
  border-radius: 2px;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul li a.klevuFilterOption .kuFilterCancel {
  margin-top: 2px;
  margin-left: auto;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul li a.klevuFilterOption {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul li a.klevuFilterOption .kufacet-text {
  color: #636569;
  font-size: 13px;
  letter-spacing: .8px;
  max-width: none;
  width: auto;
  margin-right: 5px;
  text-transform: capitalize;
  text-wrap: wrap;
  line-height: 22px;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul li a.klevuFilterOption .kuFilterTotal {
  color: #636569;
  font-size: 13px;
  letter-spacing: .8px;
  margin-left: auto;
  line-height: 22px;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul li a.klevuFilterOption .kuFilterTotal::after {
  content: ')';
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterNames ul li a.klevuFilterOption .kuFilterTotal::before {
  content: '(';
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterHead.kuCollapse+.kuFilterNames {
  height: auto;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterHead.kuCollapse+.kuFilterNames.kuFilterShowAll {
  height: auto !important;
  max-height: none !important;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterHead.kuCollapse+.kuFilterNames .klevuSliderFilter {
  height: auto;
  min-height: 90px;
}

.kuSearchResultsPageContainer .kuFilterBox .kuShowOpt {
  bottom: 0;
}

.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter .kuFilterHead.kuCollapse+.kuFilterNames.sliderFilterNames {
  overflow: visible
}

.kuSearchResultsPageContainer .noUi-horizontal .noUi-handle:focus,
.kuSearchResultsPageContainer .noUi-horizontal .noUi-handle:hover {
  width: 24px !important;
  height: 24px !important;
}

.klevuLanding.kuSearchResultsPageContainer .kuFilters .kuFilterBox.klevuFilter[data-filter="Price Range"] .kuFilterNames ul li a.klevuFilterOption {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}

/* MAIN RESULT CONTAINER */
.kuSearchResultsPageContainer [data-container-role=content] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0;
}

.kuSearchResultsPageContainer [data-container-role=content] header {
  grid-area: header;
  margin-left: auto;
}


.kuSearchResultsPageContainer .contentList [data-container-role=content] {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.kuSearchResultsPageContainer .kuPagination {
  padding: 0;
  margin: 0 auto;
  width: 100%;
  float: none;
  text-align: center;
}

.kuSearchResultsPageContainer .kuPagination .klevuPaginate-wrapper {
  padding: 0;
  margin: 50px auto 0;
  width: 100%;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.kuSearchResultsPageContainer .kuPagination .klevuPaginate-wrapper a.kuCurrent {
  text-decoration: underline;
  font-weight: var(--klevu-font-weight-bold);
}

.kuSearchResultsPageContainer .kuPagination .klevuPaginate-wrapper a.kuCurrent::after {
  content: '';
}

.kuSearchResultsPageContainer .kuPagination .klevuPaginate-wrapper a {
  position: relative;
  font-size: var(--klevu-font-size-base);
  color: var(--klevu-color-silver);
  border: 0;
  --size: 48px;
  width: var(--size);
  height: var(--size);
  line-height: var(--size);
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.kuSearchResultsPageContainer .kuPagination .klevuPaginate-wrapper a[rel=next]:hover::after,
.kuSearchResultsPageContainer .kuPagination .klevuPaginate-wrapper a[rel=prev]:hover::after {
  content: none;
}

/* RESULT CONTAINER */

.kuSearchResultsPageContainer [data-container-role=center] {
  display: block;
  width: calc(100% - var(--klevu-filter-width));
  margin-left: 20px;
}

.kuSearchResultsPageContainer .contentList [data-container-role=center] {
  width: auto;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
}

body.klevu-no-results .kuSearchResultsPageContainer [data-container-role=center] {
  width: 100%;
}

.kuSearchResultsPageContainer [data-container-role=center] [data-block-id=ku_landing_result_header] {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin-top: 40px;
  margin-bottom: 50px;
}


.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFiltersTitleHeading {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  color: #000;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: .8px;
  height: 44px;
  line-height: 44px;
  gap: 3px;
}


.kuSearchResultsPageContainer [data-container-role=center] [data-block-id=ku_landing_result_header] .kuDropSortBy {
  margin: 0;
  margin-left: auto;
  z-index: 2;
}


.kuSearchResultsPageContainer [data-container-role=center] [data-block-id=ku_landing_result_header] .kuDropSortBy .kuDropdownLabel {
  height: 44px;
  min-width: 300px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  color: #000;
  font-size: 12px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.kuSearchResultsPageContainer [data-container-role=center] [data-block-id=ku_landing_result_header] .kuDropSortBy .kuDropdownOptions {
  min-width: 300px;
  width: 100%;
  background-color: #fff;
}

.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions .kuDropOption:hover {
  background-color: #fff;
}

.kuSearchResultsPageContainer [data-container-role=center] [data-block-id=ku_landing_result_header] .kuDropSortBy .kuDropOption {
  --height: 44px;
  height: var(--height);
  line-height: var(--height);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  font-size: 12px;
  color: #000;
  letter-spacing: 0.8px;
  text-transform: capitalize;
}

.kuContainer .kuTabs {
  margin-bottom: 0;
}

.kuContainer .kuTabs a {
  padding: 8px;
  cursor: pointer;
  margin-right: 5px;
  color: #000;
  display: inline-block;
  position: relative;
  font-size: 12px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}


/* RESULT LIST */
.kuSearchResultsPageContainer .kuResults ul {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%/3, max(264px, 100%/5)), 1fr));
  grid-gap: 1rem;
}

body.klevu-no-results .kuSearchResultsPageContainer .kuResults ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: auto;
  -ms-flex-line-pack: center;
      align-content: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}


/* PRODUCT ITEM */
.kuSearchResultsPageContainer .kuResults ul li {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  position: relative;
  float: none;
}

.kuSearchResultsPageContainer .kuResults ul li .kuDesc {
  font-size: var(--klevu-font-size-tiny);
  line-height: var(--klevu-font-line-height-base);
  color: var(--klevu-color-black);
  text-align: left;
  margin-top: 10px;
}

.kuSearchResultsPageContainer .kuResults ul li:hover .kuProdAdditional {
  visibility: visible;
  opacity: 1;
  -webkit-box-shadow: none;
          box-shadow: none;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  height: 100%;
  border: 0;
}

.kuSearchResultsPageContainer .kuResults ul li .klevu-badges,
.kuSearchResultsPageContainer .kuResults ul li .klevu-labels {
  position: absolute;
  top: 0;
  left: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 5px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.kuSearchResultsPageContainer .kuResults ul li .klevu-labels {
  top: unset;
  bottom: 0;
  width: 100%;
}

.kuSearchResultsPageContainer .kuResults ul li .klevu-badges .klevu-top-badge,
.kuSearchResultsPageContainer .kuResults ul li .klevu-labels .klevu-bottom-badge {
  font-size: 12px;
  text-transform: uppercase;
}

.kuSearchResultsPageContainer .kuResults ul li .klevu-badges .klevu-badges-top {
  line-height: 12px;
  background-color: #586540;
  color: #fff;
  padding: 10px;
}

.kuSearchResultsPageContainer .kuResults ul li .klevu-badges-bottom {
  width: 100%;
  background-color: #000;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700 !important;
  letter-spacing: .5px;
  line-height: 22px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-size: 12px;
  padding: 5px 9px;
}


.kuSearchResultsPageContainer .kuResults ul li .klevu-badges-bottom.red-badge {
  background-color: #ce0e2d;
}

.kuSearchResultsPageContainer .kuResults ul li span.klevu-bottom-badge {
  line-height: 16px !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  vertical-align: middle;
  color: #fff;

  font-size: 16px;
  font-weight: 400;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap main .kuSearchResultsPageContainer .klevuWrap.contentListActive .kuResults ul li .kuProdWrap main,
.kuSearchResultsPageContainer .klevuWrap .kuResults ul li {
  width: 100%;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap main .kuProdTop {
  padding: 0;
  height: 100%;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdTop .kuQuickView {
  width: 100%;
  z-index: 1;
  padding: .25rem;
  position: absolute;
  bottom: 28px;
  font-weight: 300 !important;
  display: none;
  cursor: pointer;
  opacity: 1;
}

@media (max-width: 821px) {
    .kuSearchResultsPageContainer .kuResults ul li .kuProdTop .kuQuickView {
        height: 28px;
        line-height: 24px;
        position: static;
        display: block;
        border: 1px solid #000;
        padding: 0;
    }

    .kuSearchResultsPageContainer .kuResults ul li .kuProdTop .kuQuickView .klevu-quick-view {
        height: 26px;
        line-height: 28px;
    }
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdTop:hover .kuQuickView {
  display: block;
}

/* Square images */
.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap {
  height: 0 !important;
  padding-bottom: 150%;
  margin-bottom: 0;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap a {
  display: block;
  max-width: 100% !important;
  max-height: 100% !important;
  height: auto;
  width: auto;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuProdTop .klevuImgWrap a img {
  -o-object-fit: var(--klevu-image-fit);
     object-fit: var(--klevu-image-fit);
  -o-object-position: var(--klevu-image-position);
     object-position: var(--klevu-image-position);
  width: 100% !important;
  height: 100% !important;
}

/* Square images end */


/* Product Footer */
.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.kuSearchResultsPageContainer .klevuWrap.contentListActive .kuResults ul li .kuProdWrap footer {
  width: 100%;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom {
  height: 100% !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  padding: 0;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
}

.klevu-stars-small-l2 {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='fill-current w-6 h-6' viewBox='0 0 29.5 24' fill='none' stroke='rgb(89, 101, 64)' stroke-width='1.5' aria-hidden='true'%3E%3Cpath d='M12 .587l3.668 7.476 8.272 1.2-6 5.843 1.415 8.251L12 18.896l-7.355 3.861L6.06 15.106l-6-5.843 8.272-1.2L12 .587z'/%3E%3C/svg%3E");
  height: 15px;
  width: 92px !important;
  margin-top: 10px;
  -webkit-filter: brightness(0);
          filter: brightness(0);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.kuSwatchesVariantCountText {
  display: none;
}

.klevu-stars-small-l2 .klevu-rating-l2 {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='fill-current w-6 h-6' viewBox='0 0 29.5 24' style='color:rgb(89, 101, 64)' fill='currentColor' aria-hidden='true'%3E%3Cpath d='M12 .587l3.668 7.476 8.272 1.2-6 5.843 1.415 8.251L12 18.896l-7.355 3.861L6.06 15.106l-6-5.843 8.272-1.2L12 .587z'/%3E%3C/svg%3E");
  height: 15px;
  -webkit-filter: brightness(0);
          filter: brightness(0);
}

.klevuRatingCount {
  margin-top: 4px;
  line-height: 25px !important;
  font-size: 14px !important;
  margin-left: 0;
  text-align: left;
  color: #000;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .klevu-swatches.kuProdWrapHolder {
  width: 100%;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .swatch-toggle {
  background-color: #fff;
  border-width: 1px;
  width: 30px !important;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .product__colour-swatches {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  margin-top: 10px;
  display: grid;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .klevu-swatches .swatch-wrapper {
  margin: 0;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .klevu-swatches>span,
.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .swatch-group__swatch {
  display: none;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuCaptionStockOut {
  text-align: center;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuName {
  display: block !important;
  margin-bottom: 0;
  margin-top: 10px;
}

.kuSearchResultsPageContainer .kuResults ul li .swym-add-to-wishlist-view-product:after {
  font-size: 18px;
}

.kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemWrap .klevuNoResultsRecs-itemDesc .klevuNoResultsRecsTitle,
.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuName a.klevuProductClick {
  font-size: 14px;
  letter-spacing: 0;
  text-transform: capitalize;
  -ms-hyphens: auto;
      hyphens: auto;
  word-break: break-word;
  line-height: 22px;
  text-align: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: left;
      -ms-flex-pack: left;
          justify-content: left;
  color: #000;
  font-weight: 400;
  font-family: ITC Avant Garde Gothic Std Demi, sans-serif;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .klevu-brand {
  color: #3a3a3a;
  letter-spacing: .8px;
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
}

.kuSearchResultsPageContainer [data-result-view='list'] .klevuProduct main {
  display: inline-block;
  width: 100%;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuName a.klevuProductClick:hover {
  text-decoration: none;
}

.kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemPrice,
.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice {
  margin-top: 10px;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-pack: left;
      -ms-flex-pack: left;
          justify-content: left;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 5px;
}

.kuSearchResultsPageContainer .kuResults ul li button.swym-button {
  z-index: 1;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}

.kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemPrice span,
.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuSalePrice>span {
  margin: 0;
  text-align: center;
  width: 100%;
  line-height: var(--klevu-font-line-height-large);
  font-size: var(--klevu-font-size-small);
  font-weight: var(--klevu-font-weight-base);
  color: var(--klevu-color-silver) !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 5px;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuSalePrice .klevuQuickPriceGreyText {
  font-size: var(--klevu-font-size-small) !important;
  color: var(--klevu-color-silver) !important;
}

.kuSearchResultsPageContainer .klevuNoResultsRecs-itemPrice .klevuQuickPriceGreyText,
.kuSearchResultsPageContainer .kuPrice .klevuQuickPriceGreyText,
.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice>span {
  text-align: left;
  letter-spacing: 0;
  color: #000 !important;
  font-size: 14px !important;
  line-height: 22px;
  font-weight: 700 !important;
  white-space: nowrap;
  float: none;
  display: block !important;
  width: auto !important;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuOrigPrice {
  margin: 0;
  color: #c5c5c5 !important;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuSalePrice.kuSpecialPrice.kuClippedOne {
  color: #ce0e2d !important;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuDiscountPercentage {
  width: 100%;
}



.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdAdditional {
  position: relative;
  background: transparent;
  padding: 0;
  margin: 0;
  z-index: auto;
  visibility: visible;
  opacity: 1;
  width: 100%;
  left: auto;
  right: auto;
  top: auto;
  border: 0;
  margin-top: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData {
  visibility: visible;
  opacity: 1;
  -webkit-box-shadow: none;
          box-shadow: none;
  position: unset;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 10px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  width: 100%;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData .kuAddtocart {
  margin: 0;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData .kuAddtocart>a {
  margin: 0;
  padding: 0 20px 0 20px;
  width: 100%;
  border: 0;
  --height: 40px;
  line-height: var(--height);
  height: var(--height);
}


/* END OF THE STRUCTURED CSS SELECTORS INSTEAD OF ORIGINAL ONES */

.kuSearchResultsPageContainer .kuResultsHeadingTitleContainer,
.kuSearchResultsPageContainer .kuShowOpt,
.kuSearchResultsPageContainer [data-container-role=left] .kuFilters .klevu-facet-buttons,
.kuSearchResultsPageContainer [ku-container] #ku-filter-toggler,
.kuSearchResultsPageContainer [data-container-role=left] .kuFilters #kuFilterClose,
/* .kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFiltersTitleHeading, */
.kuSearchResultsPageContainer .kuDropdown.kuDropItemsPerpage,
.kuSearchResultsPageContainer .kuLandingResultsViewSwitchContainer {
  display: none;
}

.kuSearchResultsPageContainer [ku-container] .kuNoRecordsFoundLabelText {
  font-size: var(--klevu-font-size-base);
}

.kuSearchResultsPageContainer .kuDropdown {
  z-index: 2;
}

.kuSearchResultsPageContainer .kuDropdown .kuDropdownLabel:after {
  top: calc(50% - 7px);
}


/* No results, square images */
.kuSearchResultsPageContainer .kuLandingNoResults {
  max-width: none;
}

.kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-gap: 30px;
  width: 100% !important;
  max-width: 100% !important;
  padding: 0;
}

.kuLandingNoRecordFound .klevuNoResultsRecs h3 {
  text-align: center;
}

.kuSearchResultsPageContainer .klevuNoResultsRecs {
  margin-bottom: 10px !important;
}


.kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemWrap {
  width: 100% !important;
  margin: 0;
  padding: 0;
  position: relative;
  float: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  height: 100%;
  border: 0;
}

/* PRODUCT ITEM */
.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  position: relative;
  float: none;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuDesc {
  font-size: var(--klevu-font-size-tiny);
  line-height: var(--klevu-font-line-height-base);
  color: var(--klevu-color-black);
  text-align: center;
  margin-top: 10px;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li:hover .kuProdAdditional {
  visibility: visible;
  opacity: 1;
  -webkit-box-shadow: none;
          box-shadow: none;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  height: 100%;
  border: 0;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .klevu-badges {
  position: absolute;
  top: 0;
  left: 0;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .klevu-badges .klevu-top-badge {
  font-size: 12px;
  text-transform: uppercase;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .klevu-badges .klevu-badges-top {
  line-height: 12px;
  background-color: #586540;
  color: #fff;
  padding: 10px;
}

@media screen and (max-width: 768px) {
    .kuSearchResultsPageContainer .kuResults ul li .klevu-badges,
    .kuSearchResultsPageContainer .kuResults ul li .klevu-labels {
      gap: 3px;
    }

    .kuSearchResultsPageContainer .kuResults ul li .klevu-badges .klevu-top-badge,
    .kuSearchResultsPageContainer .kuResults ul li .klevu-labels .klevu-bottom-badge,
    .kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .klevu-badges .klevu-top-badge {
        font-size: 11px;
    }

    .kuSearchResultsPageContainer .kuResults ul li .klevu-badges .klevu-badges-top,
    .kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .klevu-badges .klevu-badges-top {
        line-height: 11px;
        padding: 5px 8px;
    }
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .klevu-badges-bottom {
  background-color: #000;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700 !important;
  letter-spacing: .5px;
  line-height: 22px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-size: 12px;
  padding: 5px 9px;
}


.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .klevu-badges-bottom.red-badge {
  background-color: #ce0e2d;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li span.klevu-bottom-badge {
  line-height: 16px !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  vertical-align: middle;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap main .kuSearchResultsPageContainer .klevuWrap.contentListActive .klevuNoResultsRecsResults ul li .kuProdWrap main,
.kuSearchResultsPageContainer .klevuWrap .klevuNoResultsRecsResults ul li {
  width: 100%;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap main .kuProdTop {
  padding: 0;
  height: 100%;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdTop .kuQuickView {
  width: 100%;
  z-index: 1;
  padding: .25rem;
  position: absolute;
  bottom: 0;
  font-weight: 300 !important;
  display: none;
  cursor: pointer;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdTop:hover .kuQuickView {
  display: block;
}

/* Square images */
.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap .kuProdTop .klevuImgWrap {
  height: 0 !important;
  padding-bottom: 150%;
  margin-bottom: 0;
  position: relative;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap .kuProdTop .klevuImgWrap a {
  display: block;
  max-width: 100% !important;
  max-height: 100% !important;
  height: auto;
  width: auto;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap .kuProdTop .klevuImgWrap a img {
  -o-object-fit: var(--klevu-image-fit);
     object-fit: var(--klevu-image-fit);
  -o-object-position: var(--klevu-image-position);
     object-position: var(--klevu-image-position);
  width: 100% !important;
  height: 100% !important;
}

/* Square images end */


/* Product Footer */
.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.kuSearchResultsPageContainer .klevuWrap.contentListActive .klevuNoResultsRecsResults ul li .kuProdWrap footer {
  width: 100%;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom {
  height: 100% !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  padding: 0 0 15px;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData .kuSwatches,
.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuSwatches {
  padding: 0;
  margin: 0;
  max-width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  min-height: 0;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuSwatches .kuSwatchItem,
.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData .kuSwatches .kuSwatchItem {
  height: 30px;
  width: 30px;
  max-height: 30px;
  max-width: 30px;
  border: 1px solid #000;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuSwatches .kuSwatchItem .kuSwatchLink,
.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData .kuSwatches .kuSwatchItem .kuSwatchLink {
  outline: none;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuSwatches .kuSwatchItem .kuSwatchLink .kuSwatchMoreText,
.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData .kuSwatches .kuSwatchItem .kuSwatchLink .kuSwatchMoreText {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .kuCaptionStockOut {
  text-align: center;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .kuName {
  display: block !important;
  margin-bottom: 0;
  margin-top: 10px;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .swym-add-to-wishlist-view-product:after {
  font-size: 18px;
}

.kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemWrap .klevuNoResultsRecs-itemDesc .klevuNoResultsRecsTitle,
.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .kuName a.klevuProductClick {
  font-size: 14px;
  letter-spacing: 0;
  text-transform: capitalize;
  -ms-hyphens: auto;
      hyphens: auto;
  word-break: break-word;
  line-height: 22px;
  text-align: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: left;
      -ms-flex-pack: left;
          justify-content: left;
  color: #000;
  font-weight: 700;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .klevu-brand {
  color: #3a3a3a;
  letter-spacing: .8px;
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  text-align: left;
}

.kuSearchResultsPageContainer [data-result-view='list'] .klevuProduct main {
  display: inline-block;
  width: 100%;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .kuName a.klevuProductClick:hover {
  text-decoration: none;
}

.kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemPrice,
.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .kuPrice {
  margin-top: 10px;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-pack: left;
      -ms-flex-pack: left;
          justify-content: left;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 5px;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li button.swym-button {
  z-index: 1;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}

.kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemPrice span,
.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuSalePrice>span {
  margin: 0;
  text-align: center;
  width: 100%;
  line-height: var(--klevu-font-line-height-large);
  font-size: var(--klevu-font-size-small);
  font-weight: var(--klevu-font-weight-base);
  color: var(--klevu-color-silver) !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 5px;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuSalePrice .klevuQuickPriceGreyText {
  font-size: var(--klevu-font-size-small) !important;
  color: var(--klevu-color-silver) !important;
}

.kuSearchResultsPageContainer .klevuNoResultsRecs-itemPrice .klevuQuickPriceGreyText,
.kuSearchResultsPageContainer .kuPrice .klevuQuickPriceGreyText,
.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .kuPrice>span {
  text-align: left;
  letter-spacing: 0;
  color: #000 !important;
  font-size: 14px !important;
  line-height: 22px;
  font-weight: 700 !important;
  white-space: nowrap;
  float: none;
  display: block !important;
  width: auto !important;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuOrigPrice {
  margin: 0;
  color: #c5c5c5 !important;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuSalePrice.kuSpecialPrice.kuClippedOne {
  color: #ce0e2d !important;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .kuDiscountPercentage {
  width: 100%;
}



.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdAdditional {
  position: relative;
  background: transparent;
  padding: 0;
  margin: 0;
  z-index: auto;
  visibility: visible;
  opacity: 1;
  width: 100%;
  left: auto;
  right: auto;
  top: auto;
  border: 0;
  margin-top: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData {
  visibility: visible;
  opacity: 1;
  -webkit-box-shadow: none;
          box-shadow: none;
  position: unset;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 10px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  width: 100%;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData .kuAddtocart {
  margin: 0;
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData .kuAddtocart>a {
  margin: 0;
  padding: 0 20px 0 20px;
  width: 100%;
  border: 0;
  --height: 40px;
  line-height: var(--height);
  height: var(--height);
}

.kuSearchResultsPageContainer .klevuNoResultsRecsResults ul li .kuProdAdditionalData form {
  width: 100%;
}

.kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemWrap .klevuNoResultsRecs-itemDesc {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  height: 100%;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner .klevuNoResultsRecs-itemWrap .klevuNoResultsRecs-itemDesc .klevuNoResultsRecsTitle {
  display: block !important;
  margin-bottom: 5px;
  text-transform: uppercase;
  color: var(--klevu-color-black);
  font-size: var(--klevu-font-size-small);
}

.kuSearchResultsPageContainer .kuLandingNoRecordFound .kuNoResultsLandingPopularSearchTerms,
.kuSearchResultsPageContainer .kuLandingNoRecordFound .kuNoResultsLandingPopularSearchTerms li a {
  font-weight: var(--klevu-font-weight-bold);
  font-size: var(--klevu-font-size-small);
  letter-spacing: var(--klevu-letter-spacing-tiny);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 5px;
}

.kuSearchResultsPageContainer .kuLandingNoRecordFound .kuNoResultsProductRecommendationSlider {
  font-family: inherit !important;
}

/* END OF No results, square images */

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .kuCaptionVat,
.kuSearchResultsPageContainer .kuCaptionVat,
.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdBottom .kuPrice .klevuQuickPriceGreyText {
  font-size: var(--klevu-font-size-small);
}

/* this is to cope with an issue on one Shopify theme */
.klevu-filters-opened .scroll-trigger {
  -webkit-animation: initial !important;
          animation: initial !important;
  -webkit-transform: none !important;
          transform: none !important;
  opacity: 1 !important;
}

/* this is to cope with an issue on one Shopify theme END */

@media screen and (max-width: 767px) {

  .kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  .kuSearchResultsPageContainer {
    padding: 0 20px;
  }

  .kuSearchResultsPageContainer [ku-container][data-container-role="left"] {
    width: 100%;
    padding: 0 10px;
  }

  .kuSearchResultsPageContainer [ku-container] .kuResultsHeadingTitleContainer {
    width: 100%;
    padding: 0;
  }

  .kuSearchResultsPageContainer [data-container-role=content] {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    gap: 0;
  }

  .kuSearchResultsPageContainer [data-container-role=left] {
    width: 100%;
    max-width: 100%;
  }

  .kuSearchResultsPageContainer .kuResults ul {
    grid-template-columns: repeat(auto-fill, minmax(var(--klevu-product-minsize-mobile), 1fr));
  }

  .klevu-filters-opened .kuSearchResultsPageContainer .kuResults ul {
    -webkit-filter: blur(3px);
            filter: blur(3px);
    pointer-events: none;
  }

  .kuSearchResultsPageContainer [data-container-role=center] {
    width: 100%;
    margin: 0;
  }

  .kuSearchResultsPageContainer [data-container-role=center] [data-block-id=ku_landing_result_header] {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin: 20px 0 20px;
    row-gap: 20px;
  }

  .kuSearchResultsPageContainer [ku-container] #ku-filter-toggler {
    height: 44px;
    font-size: 12px;
    color: #000;
    width: calc(50% - 10px);
    margin: auto;
    border: 1px solid var(--klevu-color-light);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-left: 0;
    -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
            order: 1;
    background-color: transparent;
    text-transform: uppercase;
  }

  .kuSearchResultsPageContainer .contentList [ku-container] #ku-filter-toggler {
    width: 100%;
  }

  .kuSearchResultsPageContainer [ku-container] .kuFilterTagsContainer {
    padding: 0;
    margin: 0 0 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 10px 0;
    -webkit-box-ordinal-group: 4;
        -ms-flex-order: 3;
            order: 3;
    width: 100%;
  }

  .kuSearchResultsPageContainer [ku-container] #ku-filter-toggler>svg {
    margin-right: 5px;
  }

  .kuSearchResultsPageContainer [data-container-role=center] [data-block-id=ku_landing_result_header] {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
  }

  .kuSearchResultsPageContainer [data-container-role=center] [data-block-id=ku_landing_result_header] .kuDropSortBy {
    width: calc(50% - 10px);
    -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
            order: 2;
  }

  .kuSearchResultsPageContainer [data-container-role=center] [data-block-id=ku_landing_result_header] .kuDropSortBy .kuDropdownLabel {
    min-width: 100px;
    font-size: 12px;
    text-align: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    line-height: 44px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    padding: 1px 6px;
  }

  .kuSearchResultsPageContainer [data-container-role=center] [data-block-id=ku_landing_result_header] .kuDropSortBy .kuDropdownLabel::after {
    top: calc(50% - 6px);
  }

  .kuSearchResultsPageContainer [data-container-role=left] {
    position: relative;
    max-width: initial;
    width: 100%;
    display: block;
  }

  .kuSearchResultsPageContainer .kuFilters__header {
    background-color: #000;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFiltersTitleHeading {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 60px;
    padding: 0 56px 0 16px;
    color: var(--klevu-color-white);
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    font-size: var(--klevu-font-size-base);
    margin: 0 0 16px;
  }

  .kuSearchResultsPageContainer [data-container-role=left] .kuFilters {
    display: none;
  }

  .klevu-filters-opened .kuSearchResultsPageContainer [data-container-role=left] {
    position: relative;
  }

  .klevu-filters-opened .kuSearchResultsPageContainer [data-container-role=left] .kuFilters .kuFilterBox.klevuFilter {
    margin: 0;
    padding-left: 10px;
  }

  .klevu-filters-opened .kuSearchResultsPageContainer [data-container-role=left] .kuFilters {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    background-color: var(--klevu-color-white);
    width: 100%;
    max-height: 100vh !important;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 0;
  }

  .klevu-filters-opened .kuSearchResultsPageContainer [data-container-role=left] .kuFilters .klevu-facet-buttons .klevu-facet-buttons__button {
    width: 50%;
    color: var(--klevu-color-white);
    --height: 48px;
    line-height: var(--height);
    height: var(--height);
    margin: 0 2px;
    border: none;
  }

  .klevu-filters-opened .kuSearchResultsPageContainer [data-container-role=left] .kuFilters .klevu-facet-buttons .klevu-facet-buttons__button-apply {
    background: #000;
  }

  .klevu-filters-opened .kuSearchResultsPageContainer [data-container-role=left] .kuFilters .klevu-facet-buttons .klevu-facet-buttons__button-clear {
    background: var(--klevu-color-silver);
  }

  .klevu-filters-opened .kuSearchResultsPageContainer [data-container-role=left] .kuFilters .klevu-facet-buttons .klevu-facet-buttons__button-clear .kuFilterTagClearAll {
    width: 100%;
    height: 100%;
    display: block;
  }

  .klevu-filters-opened .kuSearchResultsPageContainer [data-container-role=left] .kuFilters .klevu-facet-buttons {
    position: sticky;
    bottom: 0;
    padding: 18px 2px 4px;
    margin-top: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    background: var(--klevu-color-white);
    z-index: 1;
  }

  body.klevu-filters-opened::after {
    content: '';
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    display: block;
    background-color: var(--klevu-color-black);
    opacity: .4;
    width: 100%;
    z-index: 12;
    -webkit-filter: none !important;
            filter: none !important;
  }

  .klevu-filters-opened .kuSearchResultsPageContainer [data-container-role=left] .kuFilters #kuFilterClose {
    display: block;
    position: absolute;
    top: 20px;
    right: 11px;
    border: none;
    background: none;
  }

  .klevu-filters-opened .kuSearchResultsPageContainer [data-container-role=left] .kuFilters #kuFilterClose svg {
    fill: var(--klevu-color-white);
  }

  .kuSearchBoxWithTerm .klevuWrap [ku-container][data-container-role="main"] .klevuResultsBlock .klevuProductsViewAll {
    top: 15px;
    right: 0;
  }

  .kuSearchResultsPageContainer .productList .kuFilters .kuFilters__header .kuFiltersTitleCounter .kuFiltersTitleCounter__count {
    font-size: 16px;
  }

}

@media screen and (max-width: 425px) {

  .kuSearchResultsPageContainer [data-container-role=center] [data-block-id=ku_landing_result_header] .kuDropSortBy .kuDropdownLabel {
    text-align: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    line-height: 130%;
  }
}

.kuSearchResultsPageContainer .kuInfiniteScrollContainer {
  margin: 0;
  margin-bottom: 40px;
}

.kuSearchResultsPageContainer .kuInfiniteScrollContainer .kuLoadMoreBtn {
  width: auto;
  margin: 0;
  border-radius: 1px;
  background-color: #fff;
  color: #000;
  text-transform: uppercase;
  -webkit-box-shadow: none;
          box-shadow: none;
  padding: 10px 30px;
  border: 1px solid;
  font-size: 14px;
  line-height: inherit;
}

[ku-container] div .klevu-total-results {
  text-align: center;
  text-transform: uppercase;
  font-size: 12px;
  margin: 40px 0;
}

[ku-container] div .kuLoadMoreBtn-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  margin-top: 0;
}

.klevu-total-results__item b {
  font-weight: 400;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap footer .kuProdAdditional .kuProdAdditionalData form {
  width: 100%;
}

.kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .product__colour-swatches {
  grid-gap: 5px !important;
}

.kuFilterBox.klevuFilter.kuMulticheck[data-filter="tags"], 
.kuFilterBox.klevuFilter.kuMulticheck[data-filter="category"] {
  display: none !important;
  visibility: hidden;
}



@media (max-width: 821px) {
  .kuSearchResultsPageContainer .kuLandingNoRecordFound .klevuNoResultsRecsResultsInner {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .kuSearchResultsPageContainer .kuResults ul li .kuProdWrap .product__colour-swatches {
    grid-template-columns: repeat(5, 1fr);
  }

  .kuSearchResultsPageContainer .kuResults ul li .swym-add-to-wishlist-view-product:after {
    font-size: 14px;
  }

  .kuSearchResultsPageContainer {
    max-width: 700px;
    padding: 0 !important;
    width: 92%;
    margin: 0 auto;
  }

  /* .kuQuickSearchResultsContainer.klevuTarget.klevu-fluid>div,
  body .kuEmptySearchBox.klevuTarget.kuQuickSearchResultsContainer.kuPersonalizedSearchRecsEnabled>div {
    top: 205px !important;
  } */
}

@media screen and (max-width: 452px) {
  .kuSearchResultsPageContainer .kuResults ul {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

`;

    klevu({
        theme: {
            setHelpers: {
                all: {
                    loadCustomKlevuStyles: function () {
                        // try {
                        //     // Check if the style is already attached
                        //     if (!document.getElementById("klevu-custom-styles")) {
                        //         var encodedCSS = encodeURIComponent(customStyleContent);
                        //         var dataURI = 'data:text/css;charset=utf-8,' + encodedCSS;
                        //         // Create a link element
                        //         var link = document.createElement('link');
                        //         link.rel = 'stylesheet';
                        //         link.type = 'text/css';
                        //         link.href = dataURI;
                        //         link.id = "klevu-custom-styles";
                        //         // Append the link element to the document's head
                        //         document.head.appendChild(link);
                        //     }
                        // } catch (error) {
                        //     console.error('Error adding klevu-custom-styles:', error);
                        // }

                        /** 
                         * Klevu way:
                         * */

                        if (!document.getElementById("klevu-custom-styles")) {
                            klevu.dom.helpers.addElementToHead({
                                name: "klevu-custom-styles", 
                                content: customStyleContent,
                                type: "css",
                            });
                        }

                    },
                    addFilterAndPaginationToURL: function () {
                        return {
                            addURLtoHistory: function (data, scope, queryId) {
                                if (typeof window.history === "undefined" || typeof window.history.pushState === "undefined") {
                                    console.error("This browser does not have the support of window.history or window.history.pushState",);
                                    return;
                                }

                                var searchPath = new URLSearchParams(window.location.search);
                                var currentSearchPath;
                                var previousSearchPath = searchPath.toString();
                                const previousFiltersSelected = klevu.dom.helpers.getQueryStringValue("Filters") || "";

                                // this is in case we're running our code where we dont have context.activeQueryId
                                var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId",);
                                if (queryId && queryId.length) {
                                    activeQueryId = queryId;
                                }

                                // Check if there any filter selected
                                let applyFilters = typeof data.localOverrides.query[activeQueryId].filters !== "undefined" ? data.localOverrides.query[activeQueryId].filters.applyFilters : {};
                                let isThereFiltersSelected = false;
                                // Check if applyFilters is an object (but not an array), and not empty
                                if (typeof applyFilters === "object" && !Array.isArray(applyFilters) && applyFilters !== null && Object.keys(applyFilters).length > 0) {
                                    isThereFiltersSelected = true;
                                }

                                // PAGINATION TO URL
                                var paginationQueryParam = "Page";
                                var productsRenderedAmount = +(document.querySelectorAll(`.kuSearchResultsPageContainer .${activeQueryId}.klevuMeta .kuResults ul li`,)?.length || 0);
                                window.klevu_currentPageGlobal = window.haveFiltersChangedFlag ? 1 : +Math.ceil(productsRenderedAmount / window.klevu_productsInitialLimit,);

                                if (+window.klevu_currentPageGlobal === 1) {
                                    searchPath.delete(paginationQueryParam);
                                } else {
                                    searchPath.set(paginationQueryParam, window.klevu_currentPageGlobal,);
                                }

                                currentSearchPath = searchPath.toString();

                                // FILTERS TO URL
                                var activeQueryFilters = klevu.getObjectPath(data, "template.query." + activeQueryId + ".filters",);
                                var filterValuesQueryParam = "";

                                if (activeQueryFilters) {
                                    klevu.each(activeQueryFilters, function (key, filter) {
                                        var selectedFilterKeyString = "";
                                        var filterOptions = filter.options;
                                        var selectedValues = "";

                                        if (filterOptions && filterOptions.length) {
                                            klevu.each(filterOptions, function (key, option) {
                                                if (option.selected === true) {
                                                    if (selectedValues.length) {
                                                        selectedValues += ",";
                                                    }
                                                    selectedValues += option.value;
                                                }
                                            });
                                        } else if (filter.type === "SLIDER") {
                                            var startValue = filter.start;
                                            var endValue = filter.end;
                                            var minValue = filter.min;
                                            var maxValue = filter.max;
                                            if (typeof startValue !== "undefined" && startValue !== null && typeof endValue !== "undefined" && endValue !== null) {
                                                if (Number(startValue) === Number(minValue) && Number(endValue) === Number(maxValue)) {// just skipping
                                                } else {
                                                    selectedValues = startValue + "-" + endValue;
                                                }
                                            }
                                        }

                                        if (selectedValues.length) {
                                            selectedFilterKeyString += encodeURIComponent(filter.key) + ":" + encodeURIComponent(selectedValues);
                                        }

                                        if (selectedFilterKeyString.length) {
                                            if (filterValuesQueryParam.length) {
                                                filterValuesQueryParam += ";";
                                            }
                                            filterValuesQueryParam += selectedFilterKeyString;
                                        }
                                    });

                                    const haveFiltersChanged = filterValuesQueryParam !== previousFiltersSelected;

                                    if (haveFiltersChanged) {
                                        window.klevu_currentPageGlobal = 1;
                                        searchPath.delete(paginationQueryParam);
                                        window.haveFiltersChangedFlag = true;
                                    }
                                }

                                if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
                                    searchPath.set("Filters", filterValuesQueryParam);
                                    if (+window.klevu_currentPageGlobal === 1) {
                                        searchPath.delete(paginationQueryParam);
                                    }
                                } else {
                                    searchPath.delete("Filters");
                                }

                                currentSearchPath = searchPath.toString();

                                // ==============================
                                // Final URL change
                                if (previousSearchPath !== currentSearchPath) {
                                    var historyState = {
                                        page: window.klevu_currentPageGlobal,
                                        filters: currentSearchPath,
                                    };
                                    window.history.pushState(historyState, null, currentSearchPath ? "?" + currentSearchPath : window.location.pathname,);
                                }
                                window.haveFiltersChangedFlag = false;
                            },

                            restoreSearchParamsOnPageLoad: function (data, scope) {
                                var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries",);
                                var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered",);
                                if (hasAlreadyTriggered)
                                    return;

                                var activeQueryId = "productList";
                                var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                                const paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
                                var matchedQueryParamId = "";
                                var matchedQueryParamValue = "";
                                window.klevuAmountOfProductsToReturn = window.klevu_productsInitialLimit * Number(paginationFromURL) || window.klevu_productsInitialLimit;

                                // This is to force Klevu server get more than 100 results
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.fields", ["1"],);

                                if (recordQueries && recordQueries.length) {
                                    klevu.each(recordQueries, function (key, recordQuery) {
                                        if (recordQuery.id) {
                                            recordQuery.settings.limit = window.klevuAmountOfProductsToReturn;
                                            recordQuery.settings.offset = 0;

                                            if ((paginationFromURL && paginationFromURL.length) || (filtersFromURL && filtersFromURL.length)) {
                                                matchedQueryParamId = recordQuery.id;
                                                matchedQueryParamValue = paginationFromURL || filtersFromURL;
                                            }
                                        }
                                    });
                                }

                                klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered", true,);

                                matchedQueryParamId = "productList";

                                if (matchedQueryParamId.length && matchedQueryParamValue.length) {
                                    activeQueryId = matchedQueryParamId;
                                    var storage = klevu.getSetting(scope.kScope.settings, "settings.storage",);
                                    if (storage.tabs) {
                                        storage.tabs.setStorage("local");
                                        storage.tabs.mergeFromGlobal();
                                        storage.tabs.addElement("active", activeQueryId);
                                        storage.tabs.mergeToGlobal();
                                    }
                                }

                                if (paginationFromURL && paginationFromURL > 1) {
                                    if (recordQueries && recordQueries.length) {
                                        klevu.each(recordQueries, function (key, recordQuery) {
                                            if (recordQuery.id === activeQueryId) {
                                                // var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                                                var limit = 0;
                                                limit = Number(limit);
                                                if (limit > 0) {
                                                    var expectedOffset = (paginationFromURL - 1) * limit;
                                                    // klevu.setObjectPath(data, "settings.fields." + activeQueryId + "0", [""]);
                                                    klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + "0", expectedOffset,);
                                                }
                                            }
                                        });
                                    }
                                }

                                // FILTERS
                                if (filtersFromURL && filtersFromURL.length) {
                                    var facets = filtersFromURL.split(";");
                                    if (facets) {
                                        klevu.each(facets, function (key, facet) {
                                            var splitFacet = facet.split(":");
                                            if (splitFacet.length) {
                                                var facetKey = decodeURIComponent(splitFacet[0]);
                                                var facetValues = decodeURIComponent(splitFacet[1]).split(",",);
                                                var applyFilters = klevu.getObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters",);

                                                if (applyFilters && applyFilters.length) {
                                                    // if there're some filters
                                                    var isExistingKey = false;
                                                    klevu.each(applyFilters, function (key, applyFilter) {
                                                        if (applyFilter.key === facetKey) {
                                                            isExistingKey = true;
                                                            klevu.each(facetValues, function (key, facetValue) {
                                                                var isFilterOptionMatched = false;
                                                                klevu.each(applyFilter.values, function (key, value) {
                                                                    if (facetValue === value) {
                                                                        isFilterOptionMatched = true;
                                                                    }
                                                                },);
                                                                if (!isFilterOptionMatched) {
                                                                    applyFilter.values.push(facetValue);
                                                                }
                                                            });
                                                        }
                                                    });
                                                    if (!isExistingKey) {
                                                        applyFilters.push({
                                                            key: facetKey,
                                                            values: facetValues,
                                                        });
                                                    }
                                                } else {
                                                    klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", [{
                                                        key: facetKey,
                                                        values: facetValues
                                                    }],);
                                                }
                                            }
                                        });
                                    }
                                }
                            },

                            updatePayloadOnPopState: function (data, scope, activeQueryId) {
                                // SET PAGINATION PAYLOAD
                                // For PopState we need to use pagination from URL, as it has the history
                                const paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page") || 1;
                                const klevuAmountOfProductsToReturn = Math.ceil(window.klevu_productsInitialLimit * Number(paginationFromURL),);

                                // This is to force Klevu server get back more than 100 results
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.fields", ["1"],);
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.limit", klevuAmountOfProductsToReturn,);
                                klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", 0,);

                                // SET FILTER PAYLOAD
                                var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                                if (filtersFromURL && filtersFromURL.length) {
                                    var facets = filtersFromURL.split(";");
                                    // loop through all facets to get its values
                                    let facetKey = "";
                                    let facetValues = [];
                                    let facetsArray = [];

                                    klevu.each(facets, function (key, facet) {
                                        var splitFacet = facet.split(":");
                                        if (splitFacet.length) {
                                            facetKey = decodeURIComponent(splitFacet[0]);
                                            facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                            facetsArray.push({
                                                key: facetKey,
                                                values: facetValues
                                            });
                                        }
                                    });
                                    // set the payload with correct filters:
                                    klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", facetsArray,);
                                } else {
                                    // reset filters if Back button pressed, and there's no filters
                                    klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", [],);
                                }
                            },

                        //     smoothScrollToClickedProduct: function () {
                        //       // Get the scroll position
                        //       var savedScrollPosition = sessionStorage.getItem("klevuScrollPosition");

                        //       if (savedScrollPosition) {
                        //           var scrollPosition = Number(savedScrollPosition) + 150;
                        //           setTimeout(function () {
                        //             window.scrollTo(0, scrollPosition);
                        //               // Custom smooth scroll function
                        //             //   smoothScrollTo(scrollPosition, 500); // 500ms for the scroll duration
                        //               sessionStorage.removeItem("klevuScrollPosition");
                        //           }, 100);
                        //       }

                        //     //   function smoothScrollTo(targetY, duration) {
                        //     //       var startY = window.scrollY || window.pageYOffset,
                        //     //           startTime = Date.now();

                        //     //       function scrollStep() {
                        //     //           var currentTime = Date.now(),
                        //     //               timeFraction = Math.min(1, (currentTime - startTime) / duration),
                        //     //               easeInOutQuad = timeFraction < 0.5
                        //     //                   ? 2 * timeFraction * timeFraction
                        //     //                   : 1 - Math.pow(-2 * timeFraction + 2, 2) / 2,
                        //     //               newY = startY + (targetY - startY) * easeInOutQuad;

                        //     //           window.scrollTo(0, newY);

                        //     //           if (timeFraction < 1) {
                        //     //               requestAnimationFrame(scrollStep);
                        //     //           }
                        //     //       }

                        //     //       requestAnimationFrame(scrollStep);
                        //     //   }
                        //   },

                          saveClickedProductCoordinates: function (data, scope) {

                              document.querySelectorAll(".klevuLanding.kuSearchResultsPageContainer .kuResults ul a").forEach(function (element) {
                                  element.addEventListener("click", function (event) {
                                      _saveCurrentScrollPosition();
                                  });
                              });

                            //   window.addEventListener("beforeunload", function (event) {
                            //       _saveCurrentScrollPosition();
                            //   })


                              function _saveCurrentScrollPosition() {
                                  // Get the current scroll position
                                  var scrollPosition = window.scrollY || window.pageYOffset;

                                  // Save the scroll position
                                  try {
                                      sessionStorage.setItem("klevuScrollPosition", scrollPosition);
                                  } catch (e) {
                                      console.error("Failed to save scroll position:", e);
                                  }
                              }

                          },

                          fixInfiniteScrollBodyHeight: function (data, scope) {

                              const currentDocumentHeight = document.documentElement.scrollHeight;
                              document.body.style.minHeight = `${currentDocumentHeight}px`;

                              // reset minHeight if there are Filters or Sorting have been selected
                              function resetMinHeightListener(selector, matchSelector) {
                                  if (document.querySelector(selector) === null) {
                                      return;
                                  }
                                  document.querySelector(selector).addEventListener('click', function ({ target }) {
                                      if (target.matches(matchSelector)) {
                                          document.body.style.minHeight = '0';
                                      }
                                  });
                              }

                              // Call the function with different selectors and matchSelectors
                              resetMinHeightListener('.klevuLanding .kuFilters', '.kuFilterBox .kuFilterNames ul li a, .kuFilterBox .kuFilterNames ul li a *');
                              resetMinHeightListener('.kuFilterTagsContainer', '.kuFilterTagValue, .kuFilterTagValue *, .kuFilterTagClearAll, .kuFilterTagClearAll *');
                              resetMinHeightListener('.kuSearchResultsPageContainer .kuDropdown', '.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions .kuDropOption, .kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions .kuDropOption *');

                          },

                            buckButtonEvent: function (event) {
                                try {
                                    // passing activeQueryId because it's lost once we reset the data below
                                    var activeQueryId = klevu.getObjectPath(window.klevuCurrentScope.element.kObject.getScope().data, "context.activeQueryId");
                                    // code to get ready to reset all the data
                                    var data = window.klevuCurrentScope.element.kObject.getScope().data;
                                    var scope = window.klevuCurrentScope.element;
                                    scope.kScope.data = scope.kObject.resetData(scope.kElem);
                                    scope.kScope.data.context.keyCode = 0;
                                    scope.kScope.data.context.eventObject = event;
                                    scope.kScope.data.context.event = "keyUp";
                                    scope.kScope.data.context.preventDefault = false;

                                    // Get payload for Filters & Pagination
                                    scope.kScope.template.getHelpers().addFilterAndPaginationToURL().updatePayloadOnPopState(data, scope, activeQueryId);

                                    // Fire request, re-render results
                                    klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);

                                    sessionStorage.setItem('klevuSortingFlag', '1');
                                } catch (error) {
                                    console.log(error)
                                }
                            }
                        }
                    },
                    keepFacetsWithSelectedOptionsOpened: function (data, scope) {
                        const selectors = {
                            kuFilterBox: '.kuFilterBox',
                            kuSelected: '.kuSelected',
                            kuFilterNames: '.kuFilterNames',
                            kuFilterNamesCollapse: '.kuFilterNames.kuFilterCollapse',
                            kuFilterHead: '.kuFilterHead',
                            kuFilterHeadExpand: '.kuFilterHead.kuExpand',
                            kuExpand: '.kuExpand',
                            kuCollapse: '.kuCollapse',
                            nouiElement: '.noUi-origin',
                            priceFacetBlock: '[data-filter="klevu_price"]',
                            kuFilterShowAll: '.kuFilterShowAll',
                            kuFilterCollapse: '.kuFilterCollapse',
                        };
                
                        /** Collapse Filters by default */
                        (function collapseAllFilters() {
                            // Replace .kuFilterHead.kuCollapse with .kuFilterHead.kuExpand
                            const kuFilterHeadElements = document.querySelectorAll(selectors.kuFilterHead);
                            kuFilterHeadElements.forEach(element => {
                                element.classList.add(selectors.kuExpand.substring(1));
                                element.classList.remove(selectors.kuCollapse.substring(1));
                            });
                
                            // Replace .kuFilterNames.kuCollapse with .kuFilterNames.kuExpand
                            const kuFilterNamesElements = document.querySelectorAll(selectors.kuFilterNames);
                            kuFilterNamesElements.forEach(element => {
                                element.classList.add(selectors.kuFilterCollapse.substring(1));
                                element.classList.remove(selectors.kuFilterShowAll.substring(1));
                            });
                        }());
               
                
                        // Regular checkbox-facets
                        // Check if the required elements exist
                        const kuSelectedElements = document.querySelectorAll(selectors.kuFilterBox + ' ' + selectors.kuSelected);
                        if (kuSelectedElements.length > 0) {
                            kuSelectedElements.forEach(selectedElement => {
                                // Find the parent element with the class kuFilterBox
                                const filterBoxParent = findParentWithClass(selectedElement, selectors.kuFilterBox);
                
                                // Look for the child with the class kuFilterHead.kuExpand
                                const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);
                
                                // Rotate icon in the title 
                                if (filterHeadChild) {
                                    filterHeadChild.classList.remove('kuExpand');
                                    filterHeadChild.classList.add('kuCollapse');
                                }
                
                                // Find the parent element with the class kuFilterNames.kuFilterCollapse
                                const filterNamesParent = findParentWithClass(selectedElement, selectors.kuFilterNamesCollapse);
                
                                // Show options
                                if (filterNamesParent) {
                                    filterNamesParent.classList.remove('kuFilterCollapse');
                                    filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                                }
                            });
                        }
                
                            // Price slider facet
                            var isThereAnyAppliedFacets = klevu.getObjectPath(
                                scope.kScope.data,
                                "localOverrides.query." +
                                scope.kScope.data.context.activeQueryId +
                                ".filters.applyFilters.filters"
                            );
                            const isPriceFacetApplied = Boolean(isThereAnyAppliedFacets?.filter(val => val.key === "klevu_price").length);
                            if (isPriceFacetApplied) {
                            // Find the parent element with the class kuFilterNames.kuFilterCollapse
                            const nouiElement = document.querySelector(`${selectors.priceFacetBlock} ${selectors.nouiElement}`);
                
                            if (nouiElement) {
                                const filterNamesParent = findParentWithClass(nouiElement, selectors.kuFilterNamesCollapse);
                
                                // Show options
                                if (filterNamesParent) {
                                    filterNamesParent.classList.remove('kuFilterCollapse');
                                    filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                                }
                
                                // Find the parent element with the class kuFilterBox
                                const filterBoxParent = findParentWithClass(nouiElement, selectors.kuFilterBox);
                
                                // Look for the child with the class kuFilterHead.kuExpand
                                const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);
                
                                // Rotate icon in the title
                                if (filterHeadChild) {
                                    filterHeadChild.classList.remove('kuExpand');
                                    filterHeadChild.classList.add('kuCollapse');
                                }
                            }
                        }
                
                        // Function-helper to find the parent element with a specified class
                        function findParentWithClass(element, className) {
                            let parent = element.parentElement;
                            while (parent) {
                                if (parent.matches(className)) {
                                    return parent;
                                }
                                parent = parent.parentElement;
                            }
                            return null; // No matching parent found
                        }
                    },
                    // smoothScrollToProductListingTop: function () {
                    //     let customOffset = 150;
                    //     const selectorsToTriggerScrollToTop = {
                    //       pagination: '.kuPagination a',
                    //       // filterOptions: '.klevuFilterOption',
                    //       // Add more selectors here as needed
                    //     }
                    //     // function _smoothScrollToKlevuTop() {
                    //     //   setTimeout(function () {
                    //     //       var target = document.getElementsByClassName('klevuMeta')[0];
                  
                    //     //       if (target) {
                    //     //           var topPosition = target.getBoundingClientRect().top + window.pageYOffset;
                  
                    //     //           window.scrollTo({
                    //     //               top: topPosition - customOffset,
                    //     //               behavior: 'smooth'
                    //     //           });
                    //     //       }
                    //     //   }, 100);
                    //     // }
                    //     function _scrollToKlevuTop() {
                    //         setTimeout(function () {
                    //             var target = document.getElementsByClassName('klevuMeta')[0];
                    
                    //             if (target) {
                    //                 var topPosition = target.getBoundingClientRect().top + window.pageYOffset;
                    
                    //                 window.scrollTo(0, topPosition - customOffset);
                    //             }
                    //         }, 100);
                    //     }
                    //     Object.values(selectorsToTriggerScrollToTop).forEach(selector => {
                    //       document.querySelectorAll(selector).forEach(el => el.addEventListener('click', _scrollToKlevuTop)); //_smoothScrollToKlevuTop
                    //     });
                    // },
                    filterToggler: function (data, scope) {
                        try {
                            const documentBody = document.body;
                            function clickHandler({ target }) {
                              if (target.matches('#ku-filter-toggler, #ku-filter-toggler *')) {
                                documentBody.classList.add("klevu-filters-opened");
                              }
                              else if (target.matches('.klevu-facet-buttons__button-apply, .klevu-facet-buttons__button-apply *, [data-container-role=left], #kuFilterClose, #kuFilterClose *')) {
                                documentBody.classList.remove("klevu-filters-opened");
                              }
                            }
                            // Check if the listener has been attached using a data attribute
                            if (!documentBody.dataset.klevuMobileFiltersClickListenerAttached) {
                              klevu.event.attach(documentBody, "click", clickHandler);
                        
                              // Set the data attribute to indicate that the listener has been attached
                              documentBody.dataset.klevuMobileFiltersClickListenerAttached = "true";
                            }
                          
                        } catch (err) { }
                    },
                    isThisPageCategory: function () {
                      const isThisPageCategory = !klevu.getSetting(klevu, "settings.flags.setRemoteConfigLanding.build");
                      const documentBody = document.body;
                    
                      if (isThisPageCategory && documentBody) {
                        documentBody.classList.add('klevu-category-page');
                      }
                    },

                    productHandle: function(dataLocal) {
                        let handle = dataLocal.url.split("/").slice(-1)[0];
                        return handle;
                    },
                  
                    myCustomSortBy: function(dataLocal) {
                        /* sets the selected option to the display */
          
                        var selectedText = "";
          
                        var klevuStorage = klevu.getSetting(klevu.settings, "settings.storage");
          
                        switch (klevuStorage.sort.getElement(dataLocal) == dataLocal ? "RELEVANCE" : klevuStorage.sort.getElement(dataLocal)) {
                          case "RELEVANCE":
                              selectedText = "Recommended";
                              break;
                          case "PRICE_ASC":
                              selectedText = "Price: Low to high";
                              break;
                          case "PRICE_DESC":
                              selectedText = "Price: High to low";
                              break;
                          case "NEW_ARRIVAL_DESC":
                              selectedText = "Newest to Oldest";
                              break;
                          default:
                              selectedText = "Recommended";
                        }
                        return selectedText;
                    },
                    triggerQuickViewFunction: function () {
                        // Get all buttons with the class kuQuickViewBtn
                        const buttons = document.querySelectorAll('.kuQuickView .klevu-quick-view');
    
                        // Iterate over each button and add an event listener
                        buttons.forEach(function (button) {
                            button.addEventListener('click', function () {
                                // Get the data-sku attribute from the clicked button
                                const handle = this.getAttribute('data-handle');
    
                                // Call the function with the SKU
                                Quickshop.createQuickshop(handle);
    
                            });
                        });
                    },
                    checkTagsForLabels: function (tagsString) {
                        const tags = tagsString.toLowerCase().split(',').map(tag => tag.trim());
                        const matchedLabels = tags
                            .filter(tag => tag.startsWith('label-'))
                            .map(tag => 
                                tag.slice(6)  // Remove 'label-'
                                   .replace(/-/g, ' ')  // Replace remaining '-' with spaces
                                   .replace(/\b\w/g, char => char.toUpperCase())  // Capitalize each word
                            );
                    
                        return matchedLabels;
                    },
                    changeUrlOfProduct: function() {
                        const swatches = document.querySelectorAll('.kuSwatchLink');
                        swatches.forEach(swatch => {
                            swatch.addEventListener('click', (e) => {    
                                // Prevent default behavior if necessary
                                e.preventDefault();
                    
                                // Get the parent footer element
                                const footer = swatch.closest('footer');
                    
                                // Find the <a> tag with the class 'klevuProductClick kuTrackRecentView'
                                const productLink = footer.querySelector('a.klevuProductClick.kuTrackRecentView');
                    
                                if (productLink) {
                                    // Get the href from the <a> tag
                                    let href = productLink.getAttribute('href');
                    
                                    // Get the data-variant value from the clicked swatch
                                    const variant = swatch.getAttribute('data-variant');
                    
                                    // Build the new URL
                                    const newUrl = `${href}?variant=${variant}`;
                    
                                    // Redirect to the new URL
                                    window.location.href = newUrl;
                                }
                            });
                        });
                    },
                    replaceBreadcrumbText: function(data) {
                        if (typeof klevu_pageCategory === 'undefined') {
                            let productsAmount = data.response.data.queryResults[0].meta.totalResultsFound;
                            let searchTerm = data.context.term;
                            // Select all elements with the class 'breadcrumbs__link'
                            const breadcrumbLinks = document.querySelectorAll('.breadcrumbs__link[href="/search"]');
                                                    
                            // Iterate through each element and change the inner text
                            breadcrumbLinks.forEach(link => {
                            link.innerText = `search: ${productsAmount} results found for "${searchTerm}" `;
                            });                       
                        }
                        
                    },
                    initSwatches: function(data) {
                        try {
                            // Get all the product IDs in the response
                            var productIds = data.template.query.productList.result;
                            var maxVisibleSwatches = window.innerWidth < 768 ? 3 : 6; // Set max visible swatches based on screen width
                    
                            // Loop through the IDs
                            klevu.each(productIds, async function (pkey, prod) {
                                // Fetch the product template from Shopify API
                                var res = await fetch(prod.url + '?view=klevu-swatches&variant=' + prod.id);
                                var templateBlock = await res.text();
                    
                                if (!res.ok) {
                                  var productCardHolder = document.querySelector('.klevuProduct[data-id="' + prod.id + '"]');
                                  productCardHolder.classList.add('ku-hide');
                                } else {
                                  // Insert the template markup into the placeholder
                                  var productCardHolder = document.querySelector('[data-id="' + prod.id + '"] div.kuProdWrapHolder');
                                  if (productCardHolder) {
                                      productCardHolder.innerHTML = templateBlock;
                      
                                      // Apply the swatch visibility toggle
                                      var swatches = productCardHolder.querySelectorAll('a');
                                      if (swatches.length > maxVisibleSwatches) {
                                          // Hide additional swatches beyond maxVisibleSwatches
                                          swatches.forEach((swatch, index) => {
                                              swatch.style.display = index < maxVisibleSwatches ? 'inline-block' : 'none';
                                          });
                      
                                          // Add toggle button
                                          var toggleButton = document.createElement('button');
                                          toggleButton.className = 'swatch-toggle';
                                          toggleButton.textContent = '+';
                                          productCardHolder.querySelector('.product__colour-swatches').appendChild(toggleButton);
                      
                                          // Toggle function for swatches
                                          toggleButton.addEventListener('click', function () {
                                              swatches.forEach((swatch, index) => {
                                                  swatch.style.display = 'inline-block';
                                              });
                                              toggleButton.style.display = 'none';
                                          });
                                      }
                                  } else {
                                      console.log('Product card holder not found for product ID:', prod.id);
                                  }
                                }
                            });
                        } catch (err) {
                            console.log('Not able to process this product because:', err);
                        }
                    },
                    initSwym: function() {
                        window.SwymCallbacks = window.SwymCallbacks || [];
                        window.SwymCallbacks.push(function (swat) {
                            swat.initializeActionButtons('.kuResults'); // Buttons can now be initialized
                        });
                    },
                },
            },
            modules: {
                resultInfiniteScroll: {
                    searchResultsPage: {
                        enable: true
                    },
                    categoryPage: {
                        enable: true
                    }
                }
            },
            search: {
                infiniteScrollOffsetLanding: 1000,
            }
        },
        
    });

  
    klevu.beforeActivation("landing, catnav", function (data, scope) {

        window.klevuCurrentScope = scope.kScope;

        // Fire helper functions
        scope.kScope.template.getHelpers().loadCustomKlevuStyles();
        // landing, catnav templates
        scope.kScope.template.setTemplate(klevuLandingTemplateFiltersCustom, 'filters', true);
        scope.kScope.template.setTemplate(klevuLandingTemplateResultsCustom, 'results', true);
        scope.kScope.template.setTemplate(klevuLandingTemplateInfiniteScrollDownCustom, 'klevuLandingTemplateInfiniteScrollDown', true);
        scope.kScope.template.setTemplate(sortByCustom, 'sortBy', true);
        scope.kScope.template.setTemplate(klevuLandingTemplateProductBlockCustom, 'productBlock', true);
        scope.kScope.template.setTemplate(klevuNoResultsPopularProductsLandingCustom, 'noResultsLandingPopularProductsTemplate', true);
        scope.kScope.template.setTemplate(klevuLandingProductRatingCountCustom, 'klevuLandingProductRatingCount', true);
      
        scope.kScope.chains.events.keyUp.remove({ name: "scrollToTop" });

        window.onpopstate = scope.kScope.template.getHelpers().addFilterAndPaginationToURL().buckButtonEvent;

        window.onscroll = function (ev) {
            if (window.innerHeight + Math.ceil(window.pageYOffset) >= document.body.offsetHeight - 50) {
                var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope.data, "context.triggeredFromInfiniteScroll");
                if (!hasAlreadyTriggered) {
                    return true;
                }
            }
        };
        
        scope.kScope.chains.template.events.add({
            name: "hideLoadMoreButtonForWindowScroll",
            fire: function (data, scope) {
                return false;
            }
        });

    });

    klevu.beforeActivation("quick", function (data, scope) {

        scope.kScope.template.getHelpers().loadCustomKlevuStyles();

        window.onscroll = function (ev) {
            if (window.innerHeight + Math.ceil(window.pageYOffset) >= document.body.offsetHeight - 50) {
                var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope.data, "context.triggeredFromInfiniteScroll");
                if (!hasAlreadyTriggered) {
                    return true;
                }
            }
        };
        
        // quick tempplates:
        klevu.each(klevu.search.extraSearchBox, function (key, box) {
            box.getScope().chains.events.submit.add({
                name: "addRecentSearchInputs",
                fire: function (data, scope) {
                    sessionStorage.removeItem("klevuScrollPosition");
                }
            });
            box.getScope().template.setTemplate(klevuQuickProductBlockTitleHeaderCustom, 'klevuQuickProductBlockTitleHeader', true);
            box.getScope().template.setTemplate(klevuQuickProductBlockCustom, 'klevuQuickProductBlock', true);
            box.getScope().template.setTemplate(klevuQuickTemplateBaseCustom, 'klevuTemplateBase', true);
            box.getScope().template.setTemplate(klevuQuickTrendingProductBlockCustom, 'klevuQuickTrendingProductBlock', true);
            box.getScope().template.setTemplate(klevuQuickRecentViewedProductBlockCustom, 'klevuQuickRecentViewedProductBlock', true);
            box.getScope().template.setTemplate(klevuSearchPersonalizationsCustom, 'klevuSearchPersonalizations', true);
        });

    });

    klevu.afterTemplateRender('quick', function (data, scope) {
        
        function setKlevuQuickPopupTopPositionVariable() {
            klevu.each(klevu.dom.find('.kuQuickSearchAutoCompleteLayout .klevuWrap'), function (key, currentElement) {
                const topPosition = currentElement.getBoundingClientRect().top;
                document.documentElement.style.setProperty('--klevuQuickPopupTopPosition', `${topPosition}px`);
            });
        }
        setKlevuQuickPopupTopPositionVariable();
        window.addEventListener('resize', setKlevuQuickPopupTopPositionVariable);

        // Function to handle when the observed element is out of view
        function handleOutOfView() {
            klevu.each(klevu.search.extraSearchBox, function (key, box) {
                var fullPage = klevu.getSetting(box.getScope().settings, "settings.search.fullPageLayoutEnabled", true);
                if (!fullPage) {
                    var target = klevu.getSetting(box.getScope().settings, "settings.search.searchBoxTarget");
                    if (target) {
                        target.style.display = "none"; // Hide the search box with inline style
                    }
                }
            });
        }

        // Function to observe the element when it's scrolled out of view
        function observeOnScroll() {
            const quickSearchWrap = document.querySelector('.kuQuickSearchAutoCompleteLayout .klevuWrap');

            if (quickSearchWrap) {
                // Create an IntersectionObserver to detect when the element is scrolled out of view
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (!entry.isIntersecting) {
                            handleOutOfView(); // Element is scrolled out of view, hide the search box
                        }
                    });
                }, { threshold: 0 }); // 0 means trigger when 0% of the element is visible

                // Start observing the element
                observer.observe(quickSearchWrap);
            }
        }

        // Attach the scroll event listener to observe when the element is scrolled out
        window.addEventListener('scroll', observeOnScroll);

    });

    klevu.afterTemplateRender("catnav,landing", function (data, scope) {        
        // Add selected FILTERS and PAGINATION to the URL
        scope.kScope.template.getHelpers().addFilterAndPaginationToURL().addURLtoHistory(data, scope);
        // scope.kScope.template.getHelpers().addFilterAndPaginationToURL().smoothScrollToClickedProduct(data, scope);
        scope.kScope.template.getHelpers().addFilterAndPaginationToURL().saveClickedProductCoordinates(data, scope);
        scope.kScope.template.getHelpers().addFilterAndPaginationToURL().fixInfiniteScrollBodyHeight(data, scope);
        scope.kScope.template.getHelpers().keepFacetsWithSelectedOptionsOpened(data, scope);
        // scope.kScope.template.getHelpers().smoothScrollToProductListingTop(data, scope); // disabled as there's no pagination. 
        scope.kScope.template.getHelpers().filterToggler(data, scope);
        scope.kScope.template.getHelpers().isThisPageCategory(data, scope);
        scope.kScope.template.getHelpers().triggerQuickViewFunction();
        scope.kScope.template.getHelpers().changeUrlOfProduct();
        scope.kScope.template.getHelpers().replaceBreadcrumbText(data);
        scope.kScope.template.getHelpers().initSwatches(data);
        scope.kScope.template.getHelpers().initSwym();
    });

    klevu.modifyRequest("catnav,landing", function (data, scope) {

        window.klevu_currentPageGlobal = 1;
        window.klevuCurrentScope = scope.kScope;
        window.klevu_productsInitialLimit = 64;
        klevu.each(data.request.current.recordQueries, function (key, query) {
            query.settings.limit = window.klevu_productsInitialLimit;
            // default number of products
        });

        // Restore Search Params On Page Load
        scope.kScope.template.getHelpers().addFilterAndPaginationToURL().restoreSearchParamsOnPageLoad(data, scope);
    
        // set the global scope
        window.klevuCurrentScope = scope.kScope;     
    
        klevu.each(data.request.current.recordQueries, function (key, query) {
            klevu.setObjectPath(query, "filters.filtersToReturn.options.limit", 100);
            klevu.setObjectPath(query, "filters.filtersToReturn.options.order", "INDEX");
        
            // No results limit
            const queryID = klevu.getObjectPath(query, "id");
            if (queryID === 'noResultsFoundPopularProductList') {
            klevu.setObjectPath(query, "settings.limit", 8);
            }
            // No results limit END

            // if (queryID === 'productList') {
            //     klevu.setObjectPath(query, "settings.limit", 32);
            // }
        });

    });

    klevu.modifyRequest('all', (data, scope) => {
        const activeCurrency = Shopify?.currency?.active;
        const isValidCurrency = typeof activeCurrency === 'string' && activeCurrency.trim() !== '' && activeCurrency.length > 0;
    
        klevu.each(data.request.current.recordQueries, (key, query) => {
            if (isValidCurrency) {
                klevu.setObjectPath(query, 'settings.priceFieldSuffix', activeCurrency);
            }
        });
    });

    klevu.modifyResponse('quick, landing, catnav', function (data, scope) {
        if (!data.template.query.productList) return;

        // Helper function to replace "_medium." with ""
        function removeMediumSuffix(imageUrl) {
            return imageUrl.replace("_medium.", ".");
        }

        klevu.each(data.template.query.productList.result, function (i, product) {
            // List of properties to be modified
            const imageProperties = ['image', 'imageHover', 'imageUrl'];

            imageProperties.forEach(prop => {
                if (product[prop]) {
                    product[prop] = removeMediumSuffix(product[prop]);
                }
            });

        });
    });

    klevu.modifyResponse("landing", function (data, scope) {
        sessionStorage.setItem('klevuLastSearchTerm', klevu.getObjectPath(scope.data, "context.term"));
    });

    klevu.modifyResponse("landing, catnav", function (data, scope) {
        // Add curreny to price range
        function formatPriceRangeOption(option, formatter) {
            if (!formatter) return; // Exit if no formatter is available
            const [minPrice, maxPrice] = option.name.replace(/\s/g, "").split("-").map(price => price.trim());
            const formattedMinPrice = formatPrice(minPrice, formatter);
            const formattedMaxPrice = maxPrice ? formatPrice(maxPrice, formatter) : '';
            option.name = formattedMaxPrice ? `${formattedMinPrice} - ${formattedMaxPrice}` : formattedMinPrice;
        }
        function formatPrice(price, { appendCurrencyAtLast, currencySymbol }) {
            return appendCurrencyAtLast ? `${price}${currencySymbol}` : `${currencySymbol}${price}`;
        }
        var kmcData = klevu.getObjectPath(klevu.search, "modules.kmcInputs.kmcData.klevu_uc_userOptions.priceFormatter", undefined);
        var priceFormatter =
            (typeof klevu_uc_userOptions !== "undefined" && klevu_uc_userOptions.priceFormatter) ?
                klevu_uc_userOptions.priceFormatter :
                kmcData;
        if (!klevu.isUndefined(data.template.query["productList"])) {
            const productList = data.template.query["productList"];
            productList.filters.forEach(function (filter) {
                if (filter.key.toLowerCase() === "price range") {
                    filter.options.forEach(function (option) {
                        formatPriceRangeOption(option, priceFormatter);
                    });
                }
            });
        }
        // END OF Add curreny to price range

        klevu.each(data.template.query.productList.filters, function (filterIndex, filter) {
            const sortOrder = SORT_ORDER[filter.key.toLowerCase()];
            if (sortOrder) {
              // Create a map to store the index of each option in the custom sort order for this filter
              const sortOrderIndexMap = {};
              sortOrder.forEach((item, index) => {
                sortOrderIndexMap[item] = index;
              });
              // Use the custom sort order to sort the filter options
              filter.options.sort(function (a, b) {
                const indexA = sortOrderIndexMap[a.name] !== undefined ? sortOrderIndexMap[a.name] : sortOrder.length;
                const indexB = sortOrderIndexMap[b.name] !== undefined ? sortOrderIndexMap[b.name] : sortOrder.length;
                if (indexA < indexB) return -1;
                if (indexA > indexB) return 1;
                return 0;
              });
            }
          });
    });


    
    klevu.beforeActivation("landing", function (data, scope) {
        if (window.location.search === '') {
            window.location.href = klevu.getObjectPath(klevu.settings,"url.landing") + '?' + klevu.getGlobalSetting("url.queryParam") + '=' + sessionStorage.getItem('klevuLastSearchTerm');
        }
    }, "afterInit");
    


var myPriceFormatters = {
    "AED": {
        "code": "AED",
        "currencySymbol": "د.إ.‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "AFN": {
        "code": "AFN",
        "currencySymbol": "؋",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "ALL": {
        "code": "ALL",
        "currencySymbol": "Lek",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "AMD": {
        "code": "AMD",
        "currencySymbol": "֏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "ANG": {
        "code": "ANG",
        "currencySymbol": "ƒ",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "AOA": {
        "code": "AOA",
        "currencySymbol": "Kz",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "ARS": {
        "code": "ARS",
        "currencySymbol": "$",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "AUD": {
        "code": "AUD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "AWG": {
        "code": "AWG",
        "currencySymbol": "ƒ",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "AZN": {
        "code": "AZN",
        "currencySymbol": "₼",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "BAM": {
        "code": "BAM",
        "currencySymbol": "КМ",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "BBD": {
        "code": "BBD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "BDT": {
        "code": "BDT",
        "currencySymbol": "৳",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 0
    },
    "BGN": {
        "code": "BGN",
        "currencySymbol": "лв.",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "BHD": {
        "code": "BHD",
        "currencySymbol": "د.ب.‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 3
    },
    "BIF": {
        "code": "BIF",
        "currencySymbol": "FBu",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "BMD": {
        "code": "BMD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "BND": {
        "code": "BND",
        "currencySymbol": "$",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "BOB": {
        "code": "BOB",
        "currencySymbol": "Bs",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "BRL": {
        "code": "BRL",
        "currencySymbol": "R$",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "BSD": {
        "code": "BSD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "BTC": {
        "code": "BTC",
        "currencySymbol": "Ƀ",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 8
    },
    "BTN": {
        "code": "BTN",
        "currencySymbol": "Nu.",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 1
    },
    "BWP": {
        "code": "BWP",
        "currencySymbol": "P",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "BYR": {
        "code": "BYR",
        "currencySymbol": "р.",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "BYN": {
        "code": "BYN",
        "currencySymbol": "р.",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "BZD": {
        "code": "BZD",
        "currencySymbol": "BZ$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "CAD": {
        "code": "CAD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "CDF": {
        "code": "CDF",
        "currencySymbol": "FC",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "CHF": {
        "code": "CHF",
        "currencySymbol": "CHF",
        "thousandsSeparator": "'",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "CLP": {
        "code": "CLP",
        "currencySymbol": "$",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 0
    },
    "CNY": {
        "code": "CNY",
        "currencySymbol": "¥",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "COP": {
        "code": "COP",
        "currencySymbol": "$",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "CRC": {
        "code": "CRC",
        "currencySymbol": "₡",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "CUC": {
        "code": "CUC",
        "currencySymbol": "CUC",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "CUP": {
        "code": "CUP",
        "currencySymbol": "$MN",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "CVE": {
        "code": "CVE",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "CZK": {
        "code": "CZK",
        "currencySymbol": "Kč",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": true,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "DJF": {
        "code": "DJF",
        "currencySymbol": "Fdj",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "DKK": {
        "code": "DKK",
        "currencySymbol": "kr.",
        "thousandsSeparator": "",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "DOP": {
        "code": "DOP",
        "currencySymbol": "RD$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "DZD": {
        "code": "DZD",
        "currencySymbol": "د.ج.‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "EGP": {
        "code": "EGP",
        "currencySymbol": "ج.م.‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "ERN": {
        "code": "ERN",
        "currencySymbol": "Nfk",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "ETB": {
        "code": "ETB",
        "currencySymbol": "ETB",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "EUR": {
        "code": "EUR",
        "currencySymbol": "€",
        "thousandsSeparator": " ",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "FJD": {
        "code": "FJD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "FKP": {
        "code": "FKP",
        "currencySymbol": "£",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "GBP": {
        "code": "GBP",
        "currencySymbol": "£",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "GEL": {
        "code": "GEL",
        "currencySymbol": "GEL",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "GHS": {
        "code": "GHS",
        "currencySymbol": "₵",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "GIP": {
        "code": "GIP",
        "currencySymbol": "£",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "GMD": {
        "code": "GMD",
        "currencySymbol": "D",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "GNF": {
        "code": "GNF",
        "currencySymbol": "FG",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "GTQ": {
        "code": "GTQ",
        "currencySymbol": "Q",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "GYD": {
        "code": "GYD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "HKD": {
        "code": "HKD",
        "currencySymbol": "HK$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "HNL": {
        "code": "HNL",
        "currencySymbol": "L.",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "HRK": {
        "code": "HRK",
        "currencySymbol": "kn",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "HTG": {
        "code": "HTG",
        "currencySymbol": "G",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "HUF": {
        "code": "HUF",
        "currencySymbol": "Ft",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "IDR": {
        "code": "IDR",
        "currencySymbol": "Rp",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "ILS": {
        "code": "ILS",
        "currencySymbol": "₪",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "INR": {
        "code": "INR",
        "currencySymbol": "₹",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "IQD": {
        "code": "IQD",
        "currencySymbol": "د.ع.‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "IRR": {
        "code": "IRR",
        "currencySymbol": "﷼",
        "thousandsSeparator": ",",
        "decimalSeparator": "/",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "ISK": {
        "code": "ISK",
        "currencySymbol": "kr.",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 0
    },
    "JMD": {
        "code": "JMD",
        "currencySymbol": "J$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "JOD": {
        "code": "JOD",
        "currencySymbol": "د.ا.‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 3
    },
    "JPY": {
        "code": "JPY",
        "currencySymbol": "¥",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "KES": {
        "code": "KES",
        "currencySymbol": "KSh",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "KGS": {
        "code": "KGS",
        "currencySymbol": "сом",
        "thousandsSeparator": " ",
        "decimalSeparator": "-",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "KHR": {
        "code": "KHR",
        "currencySymbol": "៛",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "KMF": {
        "code": "KMF",
        "currencySymbol": "CF",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "KPW": {
        "code": "KPW",
        "currencySymbol": "₩",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "KRW": {
        "code": "KRW",
        "currencySymbol": "₩",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "KWD": {
        "code": "KWD",
        "currencySymbol": "د.ك.‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 3
    },
    "KYD": {
        "code": "KYD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "KZT": {
        "code": "KZT",
        "currencySymbol": "₸",
        "thousandsSeparator": " ",
        "decimalSeparator": "-",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "LAK": {
        "code": "LAK",
        "currencySymbol": "₭",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "LBP": {
        "code": "LBP",
        "currencySymbol": "ل.ل.‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "LKR": {
        "code": "LKR",
        "currencySymbol": "₨",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 0
    },
    "LRD": {
        "code": "LRD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "LSL": {
        "code": "LSL",
        "currencySymbol": "M",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "LYD": {
        "code": "LYD",
        "currencySymbol": "د.ل.‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 3
    },
    "MAD": {
        "code": "MAD",
        "currencySymbol": "د.م.‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "MDL": {
        "code": "MDL",
        "currencySymbol": "lei",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "MGA": {
        "code": "MGA",
        "currencySymbol": "Ar",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "MKD": {
        "code": "MKD",
        "currencySymbol": "ден.",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "MMK": {
        "code": "MMK",
        "currencySymbol": "K",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "MNT": {
        "code": "MNT",
        "currencySymbol": "₮",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "MOP": {
        "code": "MOP",
        "currencySymbol": "MOP$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "MRO": {
        "code": "MRO",
        "currencySymbol": "UM",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "MTL": {
        "code": "MTL",
        "currencySymbol": "₤",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "MUR": {
        "code": "MUR",
        "currencySymbol": "₨",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "MVR": {
        "code": "MVR",
        "currencySymbol": "MVR",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 1
    },
    "MWK": {
        "code": "MWK",
        "currencySymbol": "MK",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "MXN": {
        "code": "MXN",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "MYR": {
        "code": "MYR",
        "currencySymbol": "RM",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "MZN": {
        "code": "MZN",
        "currencySymbol": "MT",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "NAD": {
        "code": "NAD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "NGN": {
        "code": "NGN",
        "currencySymbol": "₦",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "NIO": {
        "code": "NIO",
        "currencySymbol": "C$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "NOK": {
        "code": "NOK",
        "currencySymbol": "kr",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "NPR": {
        "code": "NPR",
        "currencySymbol": "₨",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "NZD": {
        "code": "NZD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "OMR": {
        "code": "OMR",
        "currencySymbol": "﷼",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 3
    },
    "PAB": {
        "code": "PAB",
        "currencySymbol": "B/.",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "PEN": {
        "code": "PEN",
        "currencySymbol": "S/.",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "PGK": {
        "code": "PGK",
        "currencySymbol": "K",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "PHP": {
        "code": "PHP",
        "currencySymbol": "₱",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "PKR": {
        "code": "PKR",
        "currencySymbol": "₨",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "PLN": {
        "code": "PLN",
        "currencySymbol": "zł",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "PYG": {
        "code": "PYG",
        "currencySymbol": "₲",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "QAR": {
        "code": "QAR",
        "currencySymbol": "﷼",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "RON": {
        "code": "RON",
        "currencySymbol": "L",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "RSD": {
        "code": "RSD",
        "currencySymbol": "Дин.",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "RUB": {
        "code": "RUB",
        "currencySymbol": "₽",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "RWF": {
        "code": "RWF",
        "currencySymbol": "RWF",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "SAR": {
        "code": "SAR",
        "currencySymbol": "﷼",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "SBD": {
        "code": "SBD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "SCR": {
        "code": "SCR",
        "currencySymbol": "₨",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "SDD": {
        "code": "SDD",
        "currencySymbol": "LSd",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "SDG": {
        "code": "SDG",
        "currencySymbol": "£‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "SEK": {
        "code": "SEK",
        "currencySymbol": "kr",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "SGD": {
        "code": "SGD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "SHP": {
        "code": "SHP",
        "currencySymbol": "£",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "SLL": {
        "code": "SLL",
        "currencySymbol": "Le",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "SOS": {
        "code": "SOS",
        "currencySymbol": "S",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "SRD": {
        "code": "SRD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "STD": {
        "code": "STD",
        "currencySymbol": "Db",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "SVC": {
        "code": "SVC",
        "currencySymbol": "₡",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "SYP": {
        "code": "SYP",
        "currencySymbol": "£",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "SZL": {
        "code": "SZL",
        "currencySymbol": "E",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "THB": {
        "code": "THB",
        "currencySymbol": "฿",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "TJS": {
        "code": "TJS",
        "currencySymbol": "TJS",
        "thousandsSeparator": " ",
        "decimalSeparator": ";",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "TMT": {
        "code": "TMT",
        "currencySymbol": "m",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "TND": {
        "code": "TND",
        "currencySymbol": "د.ت.‏",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 3
    },
    "TOP": {
        "code": "TOP",
        "currencySymbol": "T$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "TRY": {
        "code": "TRY",
        "currencySymbol": "₺",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "TTD": {
        "code": "TTD",
        "currencySymbol": "TT$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "TVD": {
        "code": "TVD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "TWD": {
        "code": "TWD",
        "currencySymbol": "NT$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "TZS": {
        "code": "TZS",
        "currencySymbol": "TSh",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "UAH": {
        "code": "UAH",
        "currencySymbol": "₴",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "UGX": {
        "code": "UGX",
        "currencySymbol": "USh",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "USD": {
        "code": "USD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "UYU": {
        "code": "UYU",
        "currencySymbol": "$U",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "UZS": {
        "code": "UZS",
        "currencySymbol": "сўм",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "VEB": {
        "code": "VEB",
        "currencySymbol": "Bs.",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "VEF": {
        "code": "VEF",
        "currencySymbol": "Bs. F.",
        "thousandsSeparator": ".",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "VND": {
        "code": "VND",
        "currencySymbol": "₫",
        "thousandsSeparator": ".",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 0
    },
    "VUV": {
        "code": "VUV",
        "currencySymbol": "VT",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 0
    },
    "WST": {
        "code": "WST",
        "currencySymbol": "WS$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "XAF": {
        "code": "XAF",
        "currencySymbol": "F",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "XCD": {
        "code": "XCD",
        "currencySymbol": "$",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "XBT": {
        "code": "XBT",
        "currencySymbol": "Ƀ",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "XOF": {
        "code": "XOF",
        "currencySymbol": "F",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "XPF": {
        "code": "XPF",
        "currencySymbol": "F",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "YER": {
        "code": "YER",
        "currencySymbol": "﷼",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s %s",
        "decimalPlaces": 2
    },
    "ZAR": {
        "code": "ZAR",
        "currencySymbol": "R",
        "thousandsSeparator": " ",
        "decimalSeparator": ",",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "ZMW": {
        "code": "ZMW",
        "currencySymbol": "ZK",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    },
    "WON": {
        "code": "WON",
        "currencySymbol": "₩",
        "thousandsSeparator": ",",
        "decimalSeparator": ".",
        "appendCurrencyAtLast": false,
        format: "%s%s",
        "decimalPlaces": 2
    }
}

klevu_uc_userOptions.priceFormatter = myPriceFormatters[Shopify?.currency?.active]; // klevu_currentCurrencyCode
    
});

/* ============== QUICK SEARCH TEMPLATES =============== */

var klevuQuickProductBlockTitleHeaderCustom = `
<div class="klevuSuggestionHeading">
    <span class="klevuHeadingText"><%=helper.translate("Products")%></span>
    </div>
    <div class="klevuProductsViewAll">
    <% var queryParam = klevu.getSetting(klevu, "settings.url.queryParam"); %>
    <a href="<%=helper.buildUrl(data.settings.landingUrl, queryParam ,helper.stripHtml(data.settings.term))%>" target="_parent"><%=helper.translate("View All")%></a>
</div>`;

var klevuQuickProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <a title="<%= updatedProductName %>" target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>"  class="klevuQuickProductInnerBlock trackProductClick kuTrackRecentView">
        <div class="klevuProductItemTop">
            <div class="klevuQuickImgWrap">
                <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
            </div>
        </div>
        <div class="klevuProductItemBottom">
            <div class="klevuQuickProductDescBlock">
                <div title="<%= updatedProductName %>" class="klevuQuickProductName kuClippedOne"> <%= updatedProductName %> </div>
                <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
                    <div class="klevu-brand"><%= dataLocal.brand %></div>
                <% } %>
                <div class="klevu-desc-l2 kuClippedOne"> <%=dataLocal.shortDesc%> </div>
                <div class="klevuQuickProductDesc kuClippedOne">
                    <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
                </div>
                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('quickProductStock', scope, data, dataLocal) %>              
                <% } else { %>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="klevuQuickProductPrice kuClippedOne">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                            <div class="klevuQuickSalePrice kuStartPrice">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                                <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                            </div>
                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                            <span class="klevuQuickOrigPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                            <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                                <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                            </span>
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                    </div>
                    <%=helper.render('searchResultProductVATLabelQuick', scope, data, dataLocal) %>
                    <% } %>
                <% } %>
                <%=helper.render('klevuQuickProductRating',scope,data,dataLocal) %>
            </div>
        </div>
        <div class="kuClearLeft"></div>
    </a>
    <%=helper.render('quickSearchProductAddToCart',scope,data,dataLocal) %>        
</li>`;

var klevuQuickTemplateBaseCustom = `
<% var noResultsClass = '';
    if(typeof data.query.productList !== 'undefined' && data.query.productList.result.length === 0){
        noResultsClass = 'klevu-no-results';
    }
%>
<div class="klevu-fluid kuPreventDocumentClick">
    <div id="klevuSearchingArea" class="klevuQuickSearchingArea <%=noResultsClass %>">
        <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
            <header ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
                <section ku-block data-block-id="ku_quick_main_header_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_header_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"top") %>                    
                </section>
                <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                    <div class="klevuSuggestionsBlock">                            
                        <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                        <%=helper.render('klevuQuickCategorySuggestions',scope) %>
                        <% if(data.showQuickFacetedLayoutCharLimitMessage == true) { %>
                            <% var quickFacetedLayoutMessage = (data.quickFacetedLayoutMinCharsTextValue) ? data.quickFacetedLayoutMinCharsTextValue : ""; %>
                            <% if(quickFacetedLayoutMessage != "") { %>
                                <span class="kuFacetedLayoutMinCharText"><%= helper.translate(quickFacetedLayoutMessage) %></span>
                            <% } %>                    
                        <% } else { %>
                            <% if(data.query.productList) { %>
                                <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                                <%= helper.render('klevuQuickTemplateTabResults',scope) %>                                                 
                                <%= helper.render('klevuQuickProducts',scope) %>
                                <%= helper.render('klevuQuickOtherContent',scope) %>
                            <% } else { %>              
                                <div class="kuSearchPersonalizationsContainer">
                                    <%= helper.render('klevuSearchPersonalizations',scope) %>    
                                </div>
                            <% } %>  
                        <% } %>
                        <%=helper.render('klevuQuickPageSuggestions',scope) %>

                    </div>
                </section>
            </header>
        
            <footer ku-container data-container-id="ku_quick_main_footer_container" data-container-role="footer">
                <section ku-block data-block-id="ku_quick_main_footer_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_footer_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"bottom") %>
                </section>
            </footer> 
        </div>
    </div>
</div>`;

var klevuQuickTrendingProductBlockCustom = `
<% 
var updatedProductName = dataLocal.name;
if(typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') {
    updatedProductName = updatedProductName.replace(dataLocal.brand, '');
}
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuQSMenuItemTarget kuTrackRecentView">
<div class="klevuProductItemTop">
    <div class="klevuQuickImgWrap">
        <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
        <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
    </div>
</div>
<div class="klevuProductItemBottom">
    <div class="klevuQuickProductDescBlock">
        <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
        <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
                <div class="klevu-brand"><%= dataLocal.brand %></div>
        <% } %>
        <div class="klevuQuickProductDesc">
            <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
            <div class="klevuQuickProductPrice">
            <%
                var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
            %>
            <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                <div class="klevuQuickSalePrice kuStartPrice">
                    <span class="klevuQuickPriceGreyText"><%=helper.translate("From")%></span>
                    <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                </div>
            <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                <span class="klevuQuickOrigPrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
                <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                    <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                </span>
            <% } else if(!Number.isNaN(kuSalePrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                </span>
            <% } else if(!Number.isNaN(kuPrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
            <% } %>
        </div>
        </div>                
    </div>
</div>        
</a>`;

var klevuQuickRecentViewedProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuTrackRecentView kuQSMenuItemTarget">
    <div class="klevuProductItemTop">
        <div class="klevuQuickImgWrap">
            <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
            <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
        </div>
    </div>
    <div class="klevuProductItemBottom">
        <div class="klevuQuickProductDescBlock">
            <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
            <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
                <div class="klevu-brand"><%= dataLocal.brand %></div>
        <% } %>
            <div class="klevuQuickProductDesc">
                <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div> <div class="klevuQuickProductPrice">
                <%
                    var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                    var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                    var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                    var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                %>
                <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                    <div class="klevuQuickSalePrice kuStartPrice">
                        <span class="klevuQuickPriceGreyText"><%=helper.translate("From")%></span>
                        <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                    </div>
                <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                    <span class="klevuQuickOrigPrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                    </span>
                    <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                        <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                    </span>
                <% } else if(!Number.isNaN(kuSalePrice)) { %>
                    <span class="klevuQuickSalePrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                    </span>
                <% } else if(!Number.isNaN(kuPrice)) { %>
                    <span class="klevuQuickSalePrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                    </span>
                <% } %>
            </div>
            </div>                
        </div>
    </div>        
</a>`;

var klevuSearchPersonalizationsCustom = `
<div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
<section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left" data-container-role="left">
    <div ku-block data-block-id="ku_quick_left_facets"></div>
    <div ku-block data-block-id="ku_quick_left_call_outs">
        <%=helper.render('kuTemplatePopularSearches',scope) %>
        <%=helper.render('kuTemplateRecentSearches',scope) %>
    </div>
    <% if (window.innerWidth >= 768) { %>
        <div ku-block data-block-id="ku_quick_left_banner"></div>
    <% } %>
</section>
<section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center" data-container-role="center">
    <header ku-block data-block-id="ku_quick_result_header"></header>
    <div ku-block data-block-id="ku_quick_result_items"></div>
                
    <div ku-block data-block-id="ku_quick_other_items">
        <%=helper.render('klevuTrendingProducts',scope) %>
        <% if (window.innerWidth < 768) { %>
            <div ku-block data-block-id="ku_quick_left_banner"></div>
        <% } %>
        <%=helper.render('klevuRecentViewedProducts',scope) %>
    </div>

    <footer ku-block data-block-id="ku_quick_result_footer"></footer>
</section>
<section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right" data-container-role="right">
    <div ku-block data-block-id="ku_quick_right_facets"></div>
    <div ku-block data-block-id="ku_quick_right_call_outs"></div>
    <div ku-block data-block-id="ku_quick_right_banner"></div>
</section>
</div>`;

/* ============ LANDING & CATNAV TEMPLATES ============= */

var klevuLandingTemplateFiltersCustom = `
<% if(data.query[dataLocal].filters.length > 0 ) { %>    
    <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">


        <div class="kuFilters__header">
            <h3 class="kuFiltersTitleHeading">
                <%=helper.translate("Filter By: ")%>
                <span class="kuFiltersTitleCounter">
                    <span class="kuFiltersTitleCounter__count">
                        <% var totalResults = data.query['productList'].meta.totalResultsFound; %>
                        <% var label = totalResults === 1 ? 'product' : 'products'; %>
                        <%= helper.translate(totalResults) + ' ' + label %>
                    </span>
                </span>
            </h3>




            <button id="kuFilterClose">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15" height="15" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve"><path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717 L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859 c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287 l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285 L284.286,256.002z"/></svg>
            </button>            
        </div>



        <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
        <% filter.isCollapsed = true; %>
            <% if(filter.type == "OPTIONS"){ %>
                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                        <%=helper.translate(filter_label)%>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames ">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <a
                                        target="_self" 
                                        href="#" 
                                        title="<%=helper.escapeHTML(filterOption.name)%>" 
                                        class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                        data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                        data-name="<%=helper.escapeHTML(filterOption.name)%>" 
                                    >
                                        <span class="kuFilterIcon"></span>
                                        <span class="kufacet-text"><%=filterOption.name%></span>
                                        <% if(filterOption.selected ==true) { %>
                                            <span class="kuFilterCancel">X</span>
                                        <% } else { %>
                                            <span class="kuFilterTotal"><%=filterOption.count%></span>
                                        <% } %>
                                    </a>
                                </li>
                                
                            <%  }); %>
                        </ul>
                        <% if(filter.options.length > 5 ) { %>
                            <div class="kuShowOpt" tabindex="-1">
                                <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span>
                            </div>
                        <% } %>
                    </div>
                </div>
            <% } else if(filter.type == "SLIDER")  { %>
                <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                        <%=helper.translate(filter_label)%>
                    </div>
                    <div class="kuFilterNames  sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
                        <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
                            <div data-querykey = "<%=dataLocal%>" data-filterkey="<%=filter.key%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
                        </div>
                    </div>
                </div>
            <% } else if (filter.type == "RATING")  { %>
                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <%=helper.translate(filter.label)%>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames  <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <a
                                        target="_self" 
                                        href="#" 
                                        title="<%=helper.escapeHTML(filterOption.name)%>" 
                                        class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                        data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                        data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                    >
                                        <span class="kuFilterIcon"></span>
                                        <span class="kufacet-text">
                                            <div class="klevuFacetStars">
                                                <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                            </div>
                                        </span>
                                        <% if(filterOption.selected ==true) { %>
                                            <span class="kuFilterCancel">X</span>
                                        <% } else { %>
                                            <span class="kuFilterTotal"><%=filterOption.count%></span>
                                        <% } %>
                                    </a>
                                </li>
                                
                            <%  }); %>
                        </ul>
                    </div>
                </div>
            <% } else { %>
                <!-- Other Facets -->
            <% } %>
        <% }); %>
        



        <div class="klevu-facet-buttons">
            <button class="klevu-facet-buttons__button klevu-facet-buttons__button-clear">
                <span class="kuFilterTagClearAll klevu-facet-buttons__text" title="<%= helper.translate('Clear Filters') %>"><%= helper.translate('Clear All') %></span>
            </button>
            <button class="klevu-facet-buttons__button klevu-facet-buttons__button-apply">
                <span class="klevu-facet-buttons__text"><%= helper.translate("Apply Filters")%></span>
            </button>
        </div>
        
        
        
        
        <!-- <div class="kuFiltersFooter">
            <a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
        </div> -->

        <!-- <button id="kuFilterClose">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15" height="15" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve"><path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717 L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859 c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287 l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285 L284.286,256.002z"/></svg>
        </button> -->
    </div>
<% } %>`;

var klevuLandingTemplateResultsCustom = `
<div class="kuResultsListing">
    <div class="productList klevuMeta" data-section="productList">
        <div class="kuResultContent">
            <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                        <div ku-block data-block-id="ku_landing_left_facets">                                
                            <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                            <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>
                            <%=helper.render('filters',scope,data,"productList") %>
                        </div>
                        <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_left_banner"></div>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                        
                        <header ku-block data-block-id="ku_landing_result_header">
                            <button id="ku-filter-toggler">
                                <svg style="pointer-events:none;" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                                    <image width="128" height="128" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAA9pJREFUeJzt3c1R20AYxvEnH/foyC1KBZAKonRAB7iD0AHuIKQCnAoMFSBOOUIqQKkAuQJyWHmGMbtCkl+vvv6/mR0YGUuvvavdlex9kQAAAAAAAAAAAAAAAABgrBJJPyStJT3vlHX1WNJbdDioC0lPel3xu+Wp+ltMRCL/Gf9WWYveYBK6VP7LRoARW6p75W/LMnLMMJKq2ZjfZE6QRo0cJi61f+Vvy2Xk2KN5V/NYKumbht/6N/JX0KPsYi8kffFsP5f0yegYh1JIuqt+NpbJpvuMUfLAa7A+jk8+gNffdBjLfC/gfeCFLTXuS6BsJPuMJVFgMhtqAGOufLQQagCrmEEcwMNI9hnTtW/jx8AfX0oqJZ1q+L2Br2JKucmh1QRtU+2zybGHppSr/FXPcUS3kt0kahU1cpjIZNcAsqiRw0yu/SvfO3ZiHBK5MbBr5Rca/hwIbzhRt0ZQVs/FBCRqNxzk4syfpFO5Mb1uvM/6Cq4PdR8GTVki171vz/JS7pred60PAAAAAAAAAAAAACM014+DhyiRdFz9ftdnIIgnk3Ql/zrMR0k/NfzFueggkXSr5gs7L/oJE4dwom4rr8lZNAGJ9lt2fxU/ZFhq2u3XlWXsoGHjVPtX/nZOwFAwQrlsGsCzXGoaE3X3ATK5HEFo559erybejv1WbuR6lF2hq4U7hVPpeFl1V3MsS8/7mR3gOD51S+B8DSaYIcSsi4GkeGN2XcIKb52GGgBmItQAJpsYsSexlpwd1zzmrdNQjqBrSd81s4WSRgrPNutcQjeB7b8C23O1nATCXq4BXgYiHqsrq1LcCBqtXJz9s7ZvzqJV9IhhrmvOomvR9U9Gm5xFpfgEcLIyuW7d1yMUctfu6SED4Euhw7HNWyRxzQ4AAAAAAAAAAABgb0P5ODiV9Ln6WVTbyJMzA2eS7hX+NsxarE2YpBO5JEhNvw9HepQJWahbmpR70QhGr2uCpJeNAIY+RD7eH0lHezz/SG7imptEg6gWslka9SSSJ45S3Wyf5VE9qbsPcCa3oLHtxOuvXldQKjfrt/Ig6atn+63hMaailFtV9LvNk87V/excevaX7bG/UPEpDnCcqZRWKWLOAtu7So33F1JEOs4YtUoStTE+OP+Ve6BCDWCp7o3AN2ewbgCh2Opy5MzZRoEFpqEcQbncTZtM7bvvIrA/S6H9hXLkzFkh934VvUYhNxO1mtAs4oYOC5lsKr+IGzYsWfQC3tksxiGRu4nTtfJJYDkBXRsBlT8hidxlSdMxn25/olK5W5S7PcL2/vWir8AAAAAAAAAAAAAAAAAAYHz+Ay8t1mZnuutoAAAAAElFTkSuQmCC" id="img_1" />
                                    <use xlink:href="#img_1" fill="#FFFFFF" stroke="none" transform="scale(0.109375 0.109375)" />
                                </svg>
                                Filters
                            </button>
                            
                            <%=helper.render('filtersTop',scope,data,"productList") %>
                            
                            <% if(helper.hasResults(data,"productList")) { %>
                                <%=helper.render('sortBy',scope,data,"productList") %>
                                <%=helper.render('limit',scope,data,"productList") %>
                                <%=helper.render('kuTemplateLandingResultsViewSwitch',scope,data,"productList") %>
                            <% } %>
                            <div class="kuClearBoth"></div>
                        </header>

                        <div ku-block data-block-id="ku_landing_result_items">
                            <div class="kuResults">
                                <% if(helper.hasResults(data,"productList")) { %>
                                    <ul>
                                        <% helper.each(data.query.productList.result,function(key,item){ %>
                                            <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                <%=helper.render('productBlock',scope,data,item) %>
                                            <% } %>
                                        <% }); %>
                                    </ul>
                                <% } else { %>
                                    <div class="kuNoRecordsFoundLabelTextContainer">
                                        <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                    </div>
                                <% } %>
                                <div class="kuClearBoth"></div>
                            </div>
                        </div>
                        
                        <div ku-block data-block-id="ku_landing_other_items">
                            <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>                               
                        </div>
                        <footer ku-block data-block-id="ku_landing_result_footer"></footer>

                        <%=helper.render('pagination',scope,data,"productList") %>
                        
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                        <div ku-block data-block-id="ku_landing_right_facets"></div>
                        <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_right_banner"></div>
                    </section>

                </div>
                <% 
                    const totalResultsFound = data.query["productList"]?.meta.totalResultsFound;
                    const noOfResults = data.query["productList"].meta.noOfResults;
                    const offset = data.query["productList"].meta.offset;

                    let currentlyShowed = offset + noOfResults;

                    if (offset <= 0) {
                        currentlyShowed = noOfResults;
                    } 
                    
                    if (offset >= noOfResults && currentlyShowed < totalResultsFound) {
                        currentlyShowed = offset + noOfResults;
                    }
                    
                    if (currentlyShowed > totalResultsFound ) {
                        currentlyShowed = totalResultsFound;
                    }
                    
                %>
                <div class="kuLoadMoreBtn-wrapper" ku-block data-block-id="ku_landing_other_items">

                    <div class="klevu-total-results">
                        <span class="klevu-total-results__item" data-current-products="<%=currentlyShowed%>"><span>1 - <%=currentlyShowed%></span></span>
                        <span class="klevu-total-results__item">of</span>
                        <span class="klevu-total-results__item" data-total-products="<%=totalResultsFound%>"><%=helper.translate ("<b>%s</b> productList", totalResultsFound) %></span>
                    </div>

                    <div class="kuInfiniteScrollContainer">
                        <button class="kuLoadMoreBtn">Load More</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <% if(data.query.contentList) { %>
        <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">
                                
                                <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                <%=helper.render('filters',scope,data,"contentList") %>

                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                            
                            <header ku-block data-block-id="ku_landing_result_header">
                                <button id="ku-filter-toggler">
                                    <svg style="pointer-events:none;" width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                                        <image width="128" height="128" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAA9pJREFUeJzt3c1R20AYxvEnH/foyC1KBZAKonRAB7iD0AHuIKQCnAoMFSBOOUIqQKkAuQJyWHmGMbtCkl+vvv6/mR0YGUuvvavdlex9kQAAAAAAAAAAAAAAAABgrBJJPyStJT3vlHX1WNJbdDioC0lPel3xu+Wp+ltMRCL/Gf9WWYveYBK6VP7LRoARW6p75W/LMnLMMJKq2ZjfZE6QRo0cJi61f+Vvy2Xk2KN5V/NYKumbht/6N/JX0KPsYi8kffFsP5f0yegYh1JIuqt+NpbJpvuMUfLAa7A+jk8+gNffdBjLfC/gfeCFLTXuS6BsJPuMJVFgMhtqAGOufLQQagCrmEEcwMNI9hnTtW/jx8AfX0oqJZ1q+L2Br2JKucmh1QRtU+2zybGHppSr/FXPcUS3kt0kahU1cpjIZNcAsqiRw0yu/SvfO3ZiHBK5MbBr5Rca/hwIbzhRt0ZQVs/FBCRqNxzk4syfpFO5Mb1uvM/6Cq4PdR8GTVki171vz/JS7pred60PAAAAAAAAAAAAACM014+DhyiRdFz9ftdnIIgnk3Ql/zrMR0k/NfzFueggkXSr5gs7L/oJE4dwom4rr8lZNAGJ9lt2fxU/ZFhq2u3XlWXsoGHjVPtX/nZOwFAwQrlsGsCzXGoaE3X3ATK5HEFo559erybejv1WbuR6lF2hq4U7hVPpeFl1V3MsS8/7mR3gOD51S+B8DSaYIcSsi4GkeGN2XcIKb52GGgBmItQAJpsYsSexlpwd1zzmrdNQjqBrSd81s4WSRgrPNutcQjeB7b8C23O1nATCXq4BXgYiHqsrq1LcCBqtXJz9s7ZvzqJV9IhhrmvOomvR9U9Gm5xFpfgEcLIyuW7d1yMUctfu6SED4Euhw7HNWyRxzQ4AAAAAAAAAAABgb0P5ODiV9Ln6WVTbyJMzA2eS7hX+NsxarE2YpBO5JEhNvw9HepQJWahbmpR70QhGr2uCpJeNAIY+RD7eH0lHezz/SG7imptEg6gWslka9SSSJ45S3Wyf5VE9qbsPcCa3oLHtxOuvXldQKjfrt/Ig6atn+63hMaailFtV9LvNk87V/excevaX7bG/UPEpDnCcqZRWKWLOAtu7So33F1JEOs4YtUoStTE+OP+Ve6BCDWCp7o3AN2ewbgCh2Opy5MzZRoEFpqEcQbncTZtM7bvvIrA/S6H9hXLkzFkh934VvUYhNxO1mtAs4oYOC5lsKr+IGzYsWfQC3tksxiGRu4nTtfJJYDkBXRsBlT8hidxlSdMxn25/olK5W5S7PcL2/vWir8AAAAAAAAAAAAAAAAAAYHz+Ay8t1mZnuutoAAAAAElFTkSuQmCC" id="img_1" />
                                        <use xlink:href="#img_1" fill="#FFFFFF" stroke="none" transform="scale(0.109375 0.109375)" />
                                    </svg>
                                    Filters
                                </button>
                                
                                <%=helper.render('filtersTop',scope,data,"contentList") %>
                                
                                <% if(helper.hasResults(data,"contentList")) { %>
                                    <%=helper.render('limit',scope,data,"contentList") %>
                                <% } %>
                                <div class="kuClearBoth"></div> 
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuClearBoth"></div>
                                <div class="kuResults">
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <ul>
                                            <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                    <%=helper.render('contentBlock',scope,data,item) %>
                                                <% }%>
                                            <% }); %>
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                            </div>
                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                            
                            <%=helper.render('pagination',scope,data,"contentList") %>

                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>
                    <% 
                        const totalResultsFound = data.query["contentList"]?.meta.totalResultsFound;
                        const noOfResults = data.query["contentList"].meta.noOfResults;
                        const offset = data.query["contentList"].meta.offset;

                        let currentlyShowed = offset + noOfResults;

                        if (offset <= 0) {
                            currentlyShowed = noOfResults;
                        } 
                        
                        if (offset >= noOfResults && currentlyShowed < totalResultsFound) {
                            currentlyShowed = offset + noOfResults;
                        }
                        
                        if (currentlyShowed > totalResultsFound ) {
                            currentlyShowed = totalResultsFound;
                        }
                        
                    %>
                    <div class="kuLoadMoreBtn-wrapper" ku-block data-block-id="ku_landing_other_items">

                        <div class="klevu-total-results">
                            <span class="klevu-total-results__item" data-current-products="<%=currentlyShowed%>"><span>1 - <%=currentlyShowed%></span></span>
                            <span class="klevu-total-results__item">of</span>
                            <span class="klevu-total-results__item" data-total-products="<%=totalResultsFound%>"><%=helper.translate ("<b>%s</b> contentList", totalResultsFound) %></span>
                        </div>

                        <div class="kuInfiniteScrollContainer">
                            <button class="kuLoadMoreBtn">Load More</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <% } %> 

</div>`;

var klevuLandingTemplatePaginationCustom = `
<% if(data.query[dataLocal].result.length > 0 ) { %>
    <%
        var resultsPerPage = data.query[dataLocal].meta.noOfResults;
        var totalResultsFound = data.query[dataLocal].meta.totalResultsFound - 1;
        const lastPageOffset = (Math.floor(totalResultsFound/resultsPerPage)*resultsPerPage);
        const currentOffsetNumber = data.query[dataLocal].meta.offset;
        const currentPage = (Math.ceil(currentOffsetNumber/resultsPerPage)+1);
        const customOffsetPrev = currentPage <= 1 ? 0 : (resultsPerPage * (currentPage - 2));
        const customOffsetNext = (currentOffsetNumber + (resultsPerPage)) >= lastPageOffset ? lastPageOffset : (currentOffsetNumber + (resultsPerPage));
        const productListLimit = data.query.productList.meta.noOfResults;
        const totalPages = (Math.ceil(totalResultsFound/resultsPerPage));
        const isLastPage = currentPage === totalPages;
        const productListTotal = data.query.productList.meta.totalResultsFound - 1;
        const lastPage = (Math.ceil(productListTotal/productListLimit) - currentPage) >= 1 ? (Math.ceil(productListTotal/productListLimit)) : 0;
    %>
    
    <div class="kuPagination kuPagination--custom">
        <div class="klevuPaginate-wrapper">

            <% if(currentOffsetNumber > 0) { %>
                <a target="_self" href="javascript:void(0)"  class="klevuPaginate klevuPaginate_prev" rel="prev" data-offset="<%= customOffsetPrev %>">
                    <svg style="pointer-events: none;" focusable="false" width="24" height="24" viewBox="2 2 24 24" role="img" aria-label="Previous Page" data-hb-id="pl-icon">
                        <title>Previous Page</title>
                        <path d="M21 13.5H8.21l5.14-5.15a.49.49 0 00-.7-.7l-6 6a.36.36 0 00-.11.16.5.5 0 000 .38.36.36 0 00.11.16l6 6a.48.48 0 00.7 0 .48.48 0 000-.7L8.21 14.5H21a.5.5 0 000-1z"></path>
                    </svg>
                </a>
            <% } %>

            <% if (currentPage === 2) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - resultsPerPage)%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage))%></a>
            <% } %>
            <% if (currentPage === 3) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-1)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - resultsPerPage)%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage))%></a>
            <% } %>
            <% if (currentPage === 4) {  %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 3))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-2)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-1)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - resultsPerPage)%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage))%></a>
            <% } %>
            <% if (currentPage >= 5) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 4))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-3)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 3))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-2)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - (resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)-1)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber - resultsPerPage)%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage))%></a>
            <% } %>
            
            <a href="javascript:void(0);" class="kuCurrent"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+1)%></a>

            <% if(totalResultsFound >= currentOffsetNumber + resultsPerPage) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+resultsPerPage)%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+2)%></a>
            <% } %>
            <% if (totalPages - currentPage >= 4) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+3)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 3))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+4)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 4))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+5)%></a>
            <% } %>
            <% if (totalPages - currentPage === 3) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+3)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 3))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+4)%></a>
            <% } %>
            <% if (totalPages - currentPage === 2) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffsetNumber+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffsetNumber/resultsPerPage)+3)%></a>
            <% } %>

            <% if(totalResultsFound >= currentOffsetNumber + resultsPerPage && totalPages > 1) { %>
                <a target="_self" href="javascript:void(0)" rel="next" class="klevuPaginate klevuPaginate_next" data-offset="<%=customOffsetNext%>">
                    <svg style="pointer-events: none;" focusable="false" width="24" height="24" viewBox="2 2 24 24" role="img" aria-label="Next" data-hb-id="pl-icon">
                        <title>Next</title>
                        <path d="M21.46 14.19a.5.5 0 000-.38.36.36 0 00-.11-.16l-6-6a.49.49 0 00-.7.7l5.14 5.15H7a.5.5 0 000 1h12.79l-5.14 5.15a.48.48 0 000 .7.48.48 0 00.7 0l6-6a.36.36 0 00.11-.16z"></path>
                    </svg>
                </a>
            <% } %>

        </div>
    </div>

<% } %>`;

const klevuLandingTemplateInfiniteScrollDownCustom = `
<% helper.each(data.query, function(key, query){ %>
    <% if (key === "productList"){ %>

    <% } %>
<% }); %>
`;

const sortByCustom = `
    <div class="kuDropdown kuDropSortBy" role="listbox">
        <div class="kuDropdownLabel">
            <%=helper.translate("Sort by : ")%><%=helper.myCustomSortBy(dataLocal)%>
        </div>
        <div class="kuDropdownOptions">
        <div class="kuDropOption kuSort" data-value="RELEVANCE" role="option">Recommended</div>
        <div class="kuDropOption kuSort" data-value="PRICE_ASC" role="option">Price: Low to high</div>
        <div class="kuDropOption kuSort" data-value="PRICE_DESC" role="option">Price: High to low</div>
        <div class="kuDropOption kuSort" data-value="NEW_ARRIVAL_DESC" role="option">Newest to Oldest</div>
        </div>
    </div>
`;

const klevuLandingTemplateProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <div class="kuProdWrap">
        <header ku-block data-block-id="ku_landing_result_item_header">
            <%=helper.render('landingProductBadge', scope, data, dataLocal) %>
        </header>
        <% var desc = [dataLocal.summaryAttribute,dataLocal.packageText,dataLocal.summaryDescription].filter(function(el) { return el; }); desc = desc.join(" "); %>
        <main ku-block data-block-id="ku_landing_result_item_info">
            <div class="kuProdTop">
                <div class="klevuImgWrap" style="aspect-ratio: 1;">
                    <button data-with-epi="true" class="product_<%=dataLocal.id%> swym-button swym-add-to-wishlist-view-product swym-icon swym-heart swym-loaded" data-swaction="addToWishlist" data-product-id="<%=dataLocal.itemGroupId%>" data-variant-id="<%=dataLocal.id%>" data-product-url="<%=dataLocal.url%>" aria-label="Add to Wishlist"><span class="swym-tooltip swym-inject swym-tooltip-clickable"><span class="swym-tooltip-text">Add to wishlist</span></span></button>

                    <a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView">
                        <img src="<%=dataLocal.image.replace('_medium', '')%>" width="240" height="240" origin="<%=dataLocal.image%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
                        <%=helper.render('landingImageRollover', scope, data, dataLocal) %>
                    </a> 
                    
                    <div class="klevu-badges"> 
                        <!--<% if (typeof dataLocal.tags !== 'undefined' && dataLocal.tags.toLowerCase().includes('back-in-stock')) { %>
                            <div class="klevu-badges-top" style="background-color: <%= typeof window.ThemeVars !== 'undefined' && ThemeVars?.theme?.accent_color ? ThemeVars.theme.accent_color : '#586540' %>">
                                <span class="klevu-top-badge">Notify Me</span>
                            </div>
                        <% } %>-->
                        <% if (typeof dataLocal.tags !== 'undefined' && dataLocal.tags.toLowerCase().includes('notify-me')) { %>
                            <div class="klevu-badges-top" style="background-color: <%= typeof window.ThemeVars !== 'undefined' && ThemeVars?.theme?.accent_color ? ThemeVars.theme.accent_color : '#586540' %>">
                                <span class="klevu-top-badge">Notify me</span>
                            </div>
                        <% } %>
                        <% if (typeof dataLocal.klevu_category !== 'undefined' && dataLocal.klevu_category.toLowerCase().includes('new arrivals')) { %>
                            <div class="klevu-badges-top" style="background-color: <%= typeof window.ThemeVars !== 'undefined' && ThemeVars?.theme?.accent_color ? ThemeVars.theme.accent_color : '#586540' %>">
                                <span class="klevu-top-badge">New</span>
                            </div>
                        <% } %>
                        <% if (typeof dataLocal.badges !== 'undefined' && dataLocal.badges !== '') { %>
                            <div class="klevu-badges-top" style="background-color: <%= typeof window.ThemeVars !== 'undefined' && ThemeVars?.theme?.accent_color ? ThemeVars.theme.accent_color : '#586540' %>">
                                <span class="klevu-top-badge"><%= dataLocal.badges %></span>
                            </div>
                        <% } %>
                    </div>
                    
                    <div class="klevu-labels">
                        <% if (Number(dataLocal?.price) > Number(dataLocal?.salePrice)) { %>
                            <div class="klevu-badges-bottom red-badge" style="background-color: <%= Shopify?.theme?.accent_color ? Shopify.theme.accent_color : '#ce0e2d' %>">
                                <span class="klevu-bottom-badge ">SALE</span>
                            </div>
                        <% } else if (typeof window.ThemeVars !== 'undefined' && 
                                window.ThemeVars.site_wide_sale && 
                                typeof window.ThemeVars.site_wide_sale.activated !== 'undefined' && 
                                window.ThemeVars.site_wide_sale.activated && 
                                typeof window.ThemeVars.site_wide_sale.banner_color !== 'undefined' && 
                                typeof window.ThemeVars.site_wide_sale.banner_text !== 'undefined' && 
                                typeof dataLocal.tags === 'string' && 
                                dataLocal.tags.toLowerCase().includes('sitewideevent')) { 
                        %>
                            <div class="klevu-badges-bottom" style="background-color: <%= window.ThemeVars.site_wide_sale.banner_color %>">
                                <span class="klevu-bottom-badge"><%= window.ThemeVars.site_wide_sale.banner_text %></span>
                            </div> 
                        <% } else if (helper.checkTagsForLabels(dataLocal.tags).length > 0) { %>
                            <div class="klevu-badges-bottom" style="background-color: <%= Shopify?.theme?.accent_color ? Shopify.theme.accent_color : '#000' %>">
                                <span class="klevu-bottom-badge"><%=helper.checkTagsForLabels(dataLocal.tags)%></span>
                            </div>
                        <% } %>
                    </div>
                </div>
                <% if (!dataLocal.tags?.toLowerCase().includes('egc')) { %>
                    <div class="prod-card__quick-view kuQuickView">
                        <button class="klevu-quick-view prod-card__quick-view__button" data-handle="<%=helper.productHandle(dataLocal)%>">+ Quick Add</button>
                    </div>
                <% } %>
            </div>
        </main>
        <footer ku-block="" data-block-id="ku_landing_result_item_footer">
            <div class="kuProdBottom">             
                <div class="kuName kuClippedOne"><a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView" title="<%= updatedProductName %>"><%= updatedProductName %></a></div>

                <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
                    <div class="klevu-brand"><%= dataLocal.brand %></div>
                <% } %>

                <%=helper.render('klevuLandingProductRating',scope,data,dataLocal) %>


                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('landingProductStock', scope, data, dataLocal) %>              
                <% } else { %>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="kuPrice">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if (typeof window.ThemeVars !== 'undefined' && 
                                window.ThemeVars.site_wide_sale && 
                                typeof window.ThemeVars.site_wide_sale.activated !== 'undefined' && 
                                window.ThemeVars.site_wide_sale.activated && 
                                typeof window.ThemeVars.site_wide_sale.promotion_percentage !== 'undefined' &&
                                typeof dataLocal.tags === 'string' && 
                                dataLocal.tags.toLowerCase().includes('sitewideevent')) { %>

                            <% let newPrice = dataLocal.salePrice - (dataLocal.salePrice / 100 * window.ThemeVars.site_wide_sale.promotion_percentage); %>

                            <span class="kuOrigPrice kuClippedOne">
                                <%= helper.processCurrency(dataLocal.currency, parseFloat(dataLocal.salePrice)) %>
                            </span>
                            <span class="kuSalePrice kuSpecialPrice kuClippedOne">
                                <%= helper.processCurrency(dataLocal.currency, parseFloat(newPrice)) %>
                            </span>

                        <% } else if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>
                            <div class="kuSalePrice kuStartPrice kuClippedOne">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                                <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                            </div>
                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                            <span class="kuOrigPrice kuClippedOne">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                            <span class="kuSalePrice kuSpecialPrice kuClippedOne">
                                <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                            </span>
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="kuSalePrice kuSpecialPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="kuSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                        <%=helper.render('searchResultProductVATLabel', scope, data, dataLocal) %>
                    </div>
                <% } %>
                <% } %>
            </div>
            <div class="kuProdAdditional">
                <div class="kuProdAdditionalData">
                    <% if(desc && desc.length) { %>
                        <div class="kuDesc kuClippedTwo"> <%=desc%> </div>
                    <% } %>
                    <div class="klevu-swatches kuProdWrapHolder">
                    </div>
                </div>
            </div>
         </footer>             
    </div>
</li>`

const klevuNoResultsPopularProductsLandingCustom = `
    <div class="kuNoResultsProductRecommendationSlider kuNoResultsPopularProducts" data-section="noResultsFoundPopularProductList">
        <% var popularProductList = klevu.getObjectPath(data,"query.noResultsFoundPopularProductList.result");%>
        <% if(popularProductList && popularProductList.length) { %>
            <div class="klevuNoResultsRecs" title="<%= helper.translate(data.landingNoResultsPopularHeading) %>">
                <h3><%= helper.translate(data.landingNoResultsPopularHeading) %> </h3>
            </div>
            <div class="klevuNoResultsRecsWrap">
                    <div class="klevuNoResultsRecsResults">
                        <ul class="klevuNoResultsRecsResultsInner">
                            <% helper.each(popularProductList, function(key, product){ %>
                                <% 
                                    var updatedProductName = product.name;
                                    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
                                        if(klevu.dom.helpers.cleanUpSku(product.sku)) {
                                            updatedProductName += klevu.dom.helpers.cleanUpSku(product.sku);
                                        }
                                    }
                                %>
                                <li ku-product-block class="klevuProduct" data-id="<%=product.id%>">
                                    <div class="kuProdWrap">
                                        <header ku-block data-block-id="ku_landing_result_item_header">
                                            <%=helper.render('landingProductBadge', scope, data, product) %>
                                        </header>
                                        <% var desc = [product.summaryAttribute,product.packageText,product.summaryDescription].filter(function(el) { return el; }); desc = desc.join(" "); %>
                                        <main ku-block data-block-id="ku_landing_result_item_info">
                                            <div class="kuProdTop">
                                                <div class="klevuImgWrap">
                                                    <button data-with-epi="true" class="product_<%=dataLocal.id%> swym-button swym-add-to-wishlist-view-product swym-icon swym-heart swym-loaded" data-swaction="addToWishlist" data-product-id="<%=product.itemGroupId%>" data-variant-id="<%=product.id%>" data-product-url="<%=product.url%>" aria-label="Add to Wishlist"><span class="swym-tooltip swym-inject swym-tooltip-clickable"><span class="swym-tooltip-text">Add to wishlist</span></span></button>

                                                    <a data-id="<%=product.id%>" href="<%=product.url%>" class="klevuProductClick kuTrackRecentView">
                                                        <img src="<%=product.image.replace('_medium', '')%>" origin="<%=product.image%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
                                                    </a> 
                                                    
                                                    <div class="klevu-badges"> 
                                                        <% if (typeof product.klevu_category !== 'undefined' && product.klevu_category.toLowerCase().includes('new arrivals')) { %>
                                                            <div class="klevu-badges-top">
                                                                <span class="klevu-top-badge">New</span>
                                                            </div>
                                                        <% } else if (typeof product.inStock !== 'undefined' && product.inStock.toLowerCase() === 'no' && typeof product.tags !== 'undefined' && product.tags.toLowerCase().includes('back-in-stock')) { %>
                                                            <div class="klevu-badges-top">
                                                                <span class="klevu-top-badge">Notify me</span>
                                                            </div>
                                                        <% } else if (typeof product.badges !== 'undefined' && product.badges !== '') { %>
                                                            <div class="klevu-badges-top">
                                                                <span class="klevu-top-badge"><%= product.badges %></span>
                                                            </div>
                                                        <% } %>
                                                    </div>

                                                    <div class="klevu-labels">
                                                        <% if (typeof window.ThemeVars !== 'undefined' && 
                                                            window.ThemeVars.site_wide_sale && 
                                                            typeof window.ThemeVars.site_wide_sale.activated !== 'undefined' && 
                                                            window.ThemeVars.site_wide_sale.activated && 
                                                            typeof window.ThemeVars.site_wide_sale.banner_color !== 'undefined' && 
                                                            typeof window.ThemeVars.site_wide_sale.banner_text !== 'undefined') { %>

                                                        <% if (typeof product.tags === 'string' && 
                                                                product.tags.toLowerCase().includes('sitewideevent')) { %>
                                                            <div class="klevu-badges-bottom" style="background-color: <%= window.ThemeVars.site_wide_sale.banner_color %>">
                                                                <span class="klevu-bottom-badge"><%= window.ThemeVars.site_wide_sale.banner_text %></span>
                                                            </div>
                                                        <% } %>
                                                        <% } else if (Number(product?.price) > Number(product?.salePrice)) { %>
                                                            <div class="klevu-badges-bottom red-badge">
                                                                <span class="klevu-bottom-badge ">SALE</span>
                                                            </div>
                                                        <% } else if (helper.checkTagsForLabels(product.tags).length > 0) { %>
                                                            <div class="klevu-badges-bottom">
                                                                <span class="klevu-bottom-badge"><%=helper.checkTagsForLabels(product.tags)%></span>
                                                            </div>
                                                        <% } %>
                                                    </div>
                                                </div>
                                            </div>
                                        </main>
                                        <footer ku-block="" data-block-id="ku_landing_result_item_footer">
                                            <div class="kuProdBottom">               
                                                <div class="kuName kuClippedOne"><a data-id="<%=product.id%>" href="<%=product.url%>" class="klevuProductClick kuTrackRecentView" title="<%= updatedProductName %>"><%= updatedProductName %></a></div>

                                                <% if (typeof product.brand !== 'undefined' && product.brand !== '') { %>
                                                    <div class="klevu-brand"><%= product.brand %></div>
                                                <% } %>
                                                <%=helper.render('klevuLandingProductRating',scope,data,product) %>

                                                <% if(product.inStock && product.inStock != "yes") { %>
                                                    <%=helper.render('landingProductStock', scope, data, product) %>              
                                                <% } else { %>
                                                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                                                    <div class="kuPrice">
                                                        <%
                                                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(product.totalVariants);
                                                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(product.startPrice,product.currency);
                                                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(product.salePrice,product.currency);
                                                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(product.price,product.currency);
                                                        %>
                                                        <% if (typeof window.ThemeVars !== 'undefined' && 
                                                                window.ThemeVars.site_wide_sale && 
                                                                typeof window.ThemeVars.site_wide_sale.activated !== 'undefined' && 
                                                                window.ThemeVars.site_wide_sale.activated && 
                                                                typeof window.ThemeVars.site_wide_sale.promotion_percentage !== 'undefined') { %>

                                                            <% let newPrice = product.salePrice - (product.salePrice / 100 * window.ThemeVars.site_wide_sale.promotion_percentage); %>

                                                            <span class="kuOrigPrice kuClippedOne">
                                                                <%= helper.processCurrency(product.currency, parseFloat(product.salePrice)) %>
                                                            </span>
                                                            <span class="kuSalePrice kuSpecialPrice kuClippedOne">
                                                                <%= helper.processCurrency(product.currency, parseFloat(newPrice)) %>
                                                            </span>

                                                        <% } else if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>
                                                            <div class="kuSalePrice kuStartPrice kuClippedOne">
                                                                <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                                                                <span><%=helper.processCurrency(product.currency,parseFloat(product.startPrice))%></span>                                
                                                            </div>
                                                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                                                            <span class="kuOrigPrice kuClippedOne">
                                                                <%= helper.processCurrency(product.currency,parseFloat(product.price)) %>
                                                            </span>
                                                            <span class="kuSalePrice kuSpecialPrice kuClippedOne">
                                                                <%=helper.processCurrency(product.currency,parseFloat(product.salePrice))%>
                                                            </span>
                                                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                                                            <span class="kuSalePrice kuSpecialPrice">
                                                                <%= helper.processCurrency(product.currency,parseFloat(product.salePrice)) %>
                                                            </span>
                                                        <% } else if(!Number.isNaN(kuPrice)) { %>
                                                            <span class="kuSalePrice">
                                                                <%= helper.processCurrency(product.currency,parseFloat(product.price)) %>
                                                            </span>
                                                        <% } %>
                                                        <%=helper.render('searchResultProductVATLabel', scope, data, product) %>
                                                    </div>
                                                <% } %>
                                                <% } %>
                                            </div>
                                            <div class="kuProdAdditional">
                                                <div class="kuProdAdditionalData">
                                                    <% if(desc && desc.length) { %>
                                                        <div class="kuDesc kuClippedTwo"> <%=desc%> </div>
                                                    <% } %>
                                                    <%=helper.render('landingProductSwatch',scope,data,product) %>
                                                </div>
                                            </div>
                                        </footer>             
                                    </div>
                                </li>
                            <% }) %>
                        </ul>
                    </div>
                </div>
            </div>
        <% } %>
    </div>
`;

const klevuLandingProductRatingCountCustom = `
    <%  if(
            typeof dataLocal.ratingCount != "undefined" && 
            dataLocal.ratingCount !== "" && 
            dataLocal.ratingCount > 0
        ) { %>
        <div class="klevuRatingCount"><%=dataLocal.ratingCount%> Reviews</div>
    <%  } %>
`;
